<template>
   <!-- <div v-if="dotsLoading" class="mt-2">
		<div class="flex items-center justify-center w-full h-16 skeleton mt-4 tableCornerRadius bg-white">
			<dots-loader/>
		</div>
    </div> -->
	<div :class="modalMode ? 'details-in-modal task-details-in-modal' : 'mb-5 mx-5 mt-3 ResponsiveControlePage'">
		<div class="mb-2" v-if="!modalMode">
			<breadCrumbs :routesArray="routesArray"></breadCrumbs>
		</div>
		<div class="row w-full h-full flex mt-2" v-if="!modalMode">
			<div class="w-2/5">
				<h1 class="title">{{ presentTaskObject.controlTitle }}</h1>
			</div>
			<div class="flex w-3/5 justify-between">
				<div>
					<p class="text-sm">
						Audit Id : <b>{{ presentAuditObject.auditId }}</b>
					</p>
				</div>
				<div>
					<p class="text-sm">
						Audit Title : <b>{{ presentAuditObject.title }}</b>
					</p>
				</div>
			</div>
		</div>
		<div class="w-full minheight">
			<div class="w-full">
				<div class="text-sm">
					<div class="mainContainer tabStructure w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey flex">
						<div class="w-80 pr-5">
							<Tabs  v-model:value="selectedTabIndex" scrollable class="heightFixing">
								<div>
									<TabList>
										<Tab v-for="(tab) in tabHead" :key="tab.id" :value="tab.id" @click="toggleTabs(tab)">
											{{ tab.displayName }}
										</Tab>
									</TabList>
								</div>
								<TabPanels class="overflow-auto hide-scrollbar">
									<TabPanel v-for="(tab) in tabHead" :key="tab.id" :value="tab.id">
										<div v-if="tabDataLoading == true">
											<div class="flex items-center justify-center w-full h-16 skeleton">
											<dots-loader/>
											</div>
										</div>
										<div v-else class="h-full">
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 1">
												<div class="pt-3 flex">
												<div class="w-6/12">
													<div>
														<div>
															<div class="font-extrabold mb-1 text-xs">
																<p>CID</p>
															</div>
														</div>
													</div>
													<p v-if="presentTaskObject.clientUniqueId"  class="mt-1 mb-3 text-sm">{{ presentTaskObject.clientUniqueId != undefined || presentTaskObject.clientUniqueId == '' ? presentTaskObject.clientUniqueId : 'N/A' }}</p>
													<p v-else class="mt-1 mb-4">-</p>
												</div>
												<div class="w-6/12">
													<p class="font-extrabold text-xs">Frequency</p>
													<p v-if="(presentTaskObject.controlFrequency)" class="mt-1 mb-3 text-sm">{{dbFrequency.find((l) => l.value == presentTaskObject.controlFrequency)?.key||'N/A'}}</p>
													<p class="text-sm mt-1 mb-3" v-else>N/A</p>
												</div>
												</div>
												<div class="flex">

												<div class="w-6/12">
													<div>
														<p class="font-extrabold mb-1 text-xs">Title</p>
													</div>
													<p v-if="presentTaskObject.controlTitle !=undefined && presentTaskObject.controlTitle != ''" class="mt-1 mb-3 text-sm">{{ presentTaskObject.controlTitle }}</p>
													<p v-else class="mt-1 mb-3 text-sm">{{ 'N/A' }}</p>
												</div>
												<div class="w-6/12">
													<p class="font-extrabold mb-1 text-xs">Type</p>
													<p class="mt-1 mb-3 text-sm">{{ presentTaskObject?.controlType||'N/A' }}</p>
												</div>
												</div>
												<div class="flex">
													<div class="w-6/12">
														<div>
															<p class="font-extrabold mb-1 text-xs">Class</p>
														</div>
														<p v-if="presentTaskObject.controlClass !=undefined && presentTaskObject.controlClass != ''" class="mt-1 mb-3 text-sm">{{ presentTaskObject.controlClass }}</p>
														<p v-else class="mt-1 mb-3 text-sm">{{ 'N/A' }}</p>
													</div>
													<div class="w-6/12">
														<div>
															<p class="font-extrabold mb-1 text-xs">Family</p>
														</div>
														<p v-if="presentTaskObject.controlFamily !=undefined && presentTaskObject.controlFamily != ''" class="mt-1 mb-3 text-sm">{{ presentTaskObject.controlFamily }}</p>
														<p v-else class="mt-1 mb-3 text-sm">{{ 'N/A' }}</p>
													</div>
													
												</div>
												 <div class="w-full">
													<p class="font-extrabold text-xs">Priority</p>
													<div v-if="presentTaskObject?.controlPriority && typeof presentTaskObject?.controlPriority === 'number'"	class="flex items-center justify-center rounded h-5 w-24 mt-2 mb-3" :class="colorLabelBg(presentTaskObject?.controlPriority)">
													<div class="text-xs" :class="colorLabelText(presentTaskObject?.controlPriority)">
													{{ getProirityLabel(presentTaskObject?.controlPriority) }}
													</div>
													</div>
													<div v-else class="text-sm mt-1 mb-3">N/A</div>
												</div>
												<div> 
													<label class="font-extrabold mt-2 text-xs">Description</label>
													<p v-if="(presentTaskObject?.Description)" class="mt-1 mb-3 text-sm">{{ presentTaskObject?.Description||'N/A' }}</p>
													<p v-else class="text-sm mt-1 mb-3">N/A</p>
												</div>
												<div> 
													<label class="font-extrabold mt-2 text-xs">Policy/Procedure</label>
													<p v-if="(presentTaskObject?.controlPolicies)" class="mt-1 mb-3 text-sm">{{ presentTaskObject?.controlPolicies||'N/A' }}</p>
													<p v-else class="text-sm mt-1 mb-3">N/A</p>
												</div>

												<div>
													<div>
														<p class="font-extrabold mb-1 text-xs">Guidance</p>
													</div>
													<p v-if="presentTaskObject.controlGuidance !=undefined && presentTaskObject.controlGuidance != ''" class="mt-1 mb-3 text-sm">{{ presentTaskObject.controlGuidance }}</p>
													<p v-else class="mt-1 mb-3 text-sm">{{ 'N/A' }}</p>
												</div>
												<div> 
													<label class="font-extrabold mt-2 mb-1  text-xs">Task</label>
													<p v-if="(presentTaskObject?.controlMaintenanceTask)" class="mt-1 mb-3 text-sm">{{ presentTaskObject?.controlMaintenanceTask||'N/A' }}</p>
													<p v-else class="text-sm mt-1 mb-3">N/A</p>
												</div>
												
												
												<div v-for="(control,index) in controlsArray" :key="control.framework" class="pt-2 pb-3">
													<div v-for="(detail) in control.controlsDetailsArray" :key="detail.controlNumber">
														<div class="flex flex-row">
															<div class="text-xs py-0.5 font-opensans bg-white font-bold h-auto flex items-center my-1.5 header">Framework {{index+1}} ({{ control.framework }})</div>
														</div>
														<div class="flex items-center">
															<div class="flex flex-row w-50 mt-2 mb-2">
																<div class="w-50 border-t border-l border-r border-b p-2 header border-lightgrey rounded-l-sm">
																	<label class="controllabel">Number</label>
																</div>
																<div class="w-50 border-t border-r border-b p-2 header border-lightgrey rounded-r-sm">
																	<div class="pl-3 flex items-center flex-wrap">
																		<div :class="[getBorder(), 'text-xs px-2 py-0.5 font-opensans bg-white font-bold h-auto flex items-center']">
																			{{ detail.controlNumber }}
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<div class="flex ">
															<label class="controllabel">Description </label>
															<div class="pl-9 pr-1 ml-1">:</div>
															<p v-if="detail.description == null || detail.description == undefined" class=" text-xs">{{ 'N/A' }}</p>
															<p v-else class=" text-xs">{{detail.description}}</p>
														</div>
														<!-- <p class="mt-1.5">{{ control.controls }}</p> -->
													</div>
												<!-- <div>
													<div class="border-b border-lightgrey">
														<p class="my-1.5 header">Description</p>
													</div>
													<p class="mt-1.5">{{ presentTaskObject.controlAuditMethodology }}</p>
												</div> -->
												</div>
											</div>
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 2">
												<div>
													<div class="border-b border-lightgrey flex justify-between pb-2 mt-3">
														<div class="flex items-center mt-0.5 marginTopForDoc marginBottomForDoc justify-center">
															<div>
																<p class="header">Documents which are related to the controls</p>
															</div>
														</div>
													</div>
													<!-- <p class="mt-1.5">{{ descriptionObject._id }}</p> -->
												</div>
											</div>
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 3">
												<div class="border-b border-lightgrey flex justify-between pb-2 mt-3">
														<div class="flex items-center justify-center">
															<div>
																<!-- <p class="header">Comments</p> -->
																<p class="my-1.5 header">Related Tasks</p>
															</div>
														</div>
														<div>
															<div class="buttonposition flex justify-center items-center">
																<div class="buttonposition flex justify-center items-center">
																	<button class="flex" @click="filterOpen" :class="tableRow.length == 0 ? 'btndisabled pointer-events-none' : 'filterButton'">
																		<img v-if="tableRow.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
																		<img v-else src="@/assets/filter.svg" class="filterIcon" />
																		Filters
																	</button>
																</div>
															</div>
														</div>
													</div>
												<div>
													<tableData :tableRowData="tableRow" :headersData="Headers"></tableData>
												</div>
											</div>
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 4">
												<div>
													<!-- <div class="border-b border-lightgrey">
														<div class="flex justify-between mb-1.5">
															<div class="header flex justify-center items-center">Files uploaded by Auditee/Asignee for Evidence</div>
															<div class="buttonposition flex justify-center items-center">
																<input  type="file" id="upload" ref="element"/>
																<button class="btnprimary w-24 flex justify-center ">Attach</button> 
																<button @click="openFilePicker" for="upload" class="btnprimary w-24 flex justify-center ">Attach</button>
																<input type="file" ref="fileInput" id="upload" @change.stop="handleFileChange" style="display: none" />
															</div>
														</div>
													</div> -->
													<div class="evidence-tab-content">
													<div class="evidence-files-block">
													<div class="border-b border-lightgrey flex justify-between items-center pb-2 mt-3">
														<div class="flex items-center justify-center">
															<p class="header">Files</p>
														</div>
														<div class="buttonposition flex justify-center items-center gap-2">
															<button @click="openLinkEvidencePopup" :class="isEvidenceAttachDisabled() ? 'btndisabled pointer-events-none': 'filterButton flex justify-center'" class="flex justify-center">Link Existing</button>
															<button @click="openFilePopup('file')" for="upload" :class="TaskDetailsDropDown.taskStatus == 10401 || TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417 || TaskDetailsDropDown.taskStatus == 10418 || !isAddDisabled(10302) ? 'btndisabled pointer-events-none': 'filterButton flex justify-center'" class="flex justify-center">Attach</button>
														</div>
													</div>
													<div v-if="fileEvidences.length" class="flex mt-5 gap-4 flex-wrap">
														<div v-for="(doc, fileIdx) in fileEvidences" :key="'file-'+fileIdx">
															<div class="pdf w-full rounded-sm">
																<a
																	href="#"
																	@click.prevent="openEvidenceFile(doc)"
																	class="flex w-full flex-row items-center cursor-pointer"
																>
																	<img src="@/assets/pdf.svg" alt="" v-if=" getEvidenceFileExt(doc)=='pdf'" />
																	<img src="@/assets/doc.svg" alt="" v-if=" getEvidenceFileExt(doc)=='doc'"/>
																	<img src="@/assets/docx.svg" alt="" v-if=" getEvidenceFileExt(doc)=='docx'" />
																	<img src="@/assets/xls.svg" alt="" v-if=" getEvidenceFileExt(doc)=='xls'" />
																	<img src="@/assets/xlsx.svg" alt="" v-if=" getEvidenceFileExt(doc)=='xlsx'" />
																	<img src="@/assets/pdf.svg" alt="" v-if=" getEvidenceFileExt(doc)=='rtf'"/>
																	<img src="@/assets/txt.svg" alt="" v-if=" getEvidenceFileExt(doc)=='txt'"/>
																	<img src="@/assets/png.svg" alt="" v-if=" getEvidenceFileExt(doc)=='png'"/>
																	<img src="@/assets/jpg.svg" alt="" v-if=" getEvidenceFileExt(doc)=='jpg'"/>
																	<img src="@/assets/jpeg.svg" alt="" v-if=" getEvidenceFileExt(doc)=='jpeg'"/>
																	<img src="@/assets/csv.svg" alt="" v-if=" getEvidenceFileExt(doc)=='csv'"/>
																	<img src="@/assets/zip.svg" alt="" v-if=" getEvidenceFileExt(doc)=='zip'"/>
																	<img src="@/assets/mp4.svg" alt="" v-if=" getEvidenceFileExt(doc)=='mp4'"/>
																	
																	<div class="flex flex-col w-full min-w-0">
																		<div class="ml-2 pb-1">
																			<p class="text-xs font-medium truncate" :title="doc.filename || doc.name">{{doc.filename || doc.name || 'N/A'}}</p>
																		</div>
																		<div class="flex justify-between w-full">
																			<p class="ml-2 fontSize10PX">{{doc.evidenceDate?formatFileAttachedTime(doc.evidenceDate):'N/A'}}</p>
																			<p class="mr-2 fontSize10PX font-semibold">{{ evidenceTaskLabel(doc) }}</p>
																		</div>
																	</div>
																	<button v-if="canDeleteAuditEvidence(doc)" type="button" class="evidence-file-delete" @click.stop.prevent="openDeleteEvidenceConfirm(presentTaskObject.files.indexOf(doc))" :class="isEvidenceAttachDisabled() ? 'pointer-events-none' : ''">
																		<img src="@/assets/deleteIcon.svg" alt="Delete" />
																	</button>
																</a>
															</div>
														</div>
													</div>
													<p v-else class="text-xs text-placeholdergray mt-3">No files attached</p>
													</div>

													<div class="evidence-links-section">
													<div class="border-b border-lightgrey flex justify-between items-center pb-2 mt-6">
														<div class="flex items-center justify-center">
															<p class="header">Links</p>
														</div>
														<div class="buttonposition flex justify-center items-center">
															<button
																@click="openFilePopup('url')"
																:class="TaskDetailsDropDown.taskStatus == 10401 || TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417 || TaskDetailsDropDown.taskStatus == 10418 || !isAddDisabled(10302) ? 'btndisabled pointer-events-none': 'filterButton flex justify-center'"
																class="flex justify-center"
															>Add Link</button>
														</div>
													</div>
													<div class="evidence-links-wrap" :class="{ 'evidence-links-wrap--empty': filteredLinkCount === 0 }">
														<div class="evidence-links-scroll">
															<div class="evidence-links-header">
																<table class="evidence-links-table" :style="linkTableResizeStyle">
																	<thead>
																		<tr>
																			<th class="cursor-pointer evidence-links-col-id" @click="sortLinkEvidences('taskId')">
																				<div class="flex items-center">
																					<div>ID</div>
																					<div class="sort cursor-pointer" :class="linkSortKey === 'taskId' ? linkSortClass : 'opacity-50'"></div>
																				</div>
																			</th>
																			<th class="cursor-pointer evidence-links-col-title" @click="sortLinkEvidences('filename')">
																				<div class="flex items-center">
																					<div>Link Title</div>
																					<div class="sort cursor-pointer" :class="linkSortKey === 'filename' ? linkSortClass : 'opacity-50'"></div>
																				</div>
																			</th>
																			<th class="cursor-pointer evidence-links-col-link" @click="sortLinkEvidences('url')">
																				<div class="flex items-center">
																					<div>Link</div>
																					<div class="sort cursor-pointer" :class="linkSortKey === 'url' ? linkSortClass : 'opacity-50'"></div>
																				</div>
																			</th>
																			<th class="cursor-pointer evidence-links-col-date" @click="sortLinkEvidences('evidenceDate')">
																				<div class="flex items-center">
																					<div>Evidence Date</div>
																					<div class="sort cursor-pointer" :class="linkSortKey === 'evidenceDate' ? linkSortClass : 'opacity-50'"></div>
																				</div>
																			</th>
																			<th class="evidence-links-col-action"></th>
																		</tr>
																	</thead>
																</table>
															</div>
															<div class="evidence-links-body">
																<table class="evidence-links-table" :style="linkTableResizeStyle">
																	<tbody v-if="paginatedLinkEvidences.length">
																		<tr
																			v-for="(doc, idx) in paginatedLinkEvidences"
																			:key="'link-'+idx"
																			class="rowHeight evidence-links-row"
																		>
																			<td class="evidence-links-col-id" :title="evidenceTaskLabel(doc)">
																				<div class="table-ellipsis">{{ evidenceTaskLabel(doc) }}</div>
																			</td>
																			<td class="evidence-links-col-title" :title="doc.filename || doc.name">
																				<div class="table-ellipsis">{{ doc.filename || doc.name || 'N/A' }}</div>
																			</td>
																			<td class="evidence-links-col-link">
																				<div class="table-ellipsis">
																					<a href="#" class="text-primary evidence-link-anchor cursor-pointer" @click.prevent="openEvidenceFile(doc)" :title="doc.url">{{ doc.url }}</a>
																				</div>
																			</td>
																			<td class="evidence-links-col-date">{{ doc.evidenceDate ? formatFileAttachedTime(doc.evidenceDate) : 'N/A' }}</td>
																			<td class="evidence-links-col-action">
																				<button v-if="canDeleteAuditEvidence(doc)" type="button" class="evidence-links-delete" @click.stop.prevent="openDeleteEvidenceConfirm(presentTaskObject.files.indexOf(doc))" :class="isEvidenceAttachDisabled() ? 'pointer-events-none' : ''">
																					<img src="@/assets/deleteIcon.svg" alt="Delete" class="h-5 w-5" />
																				</button>
																			</td>
																		</tr>
																	</tbody>
																	<tbody v-else>
																		<tr>
																			<td class="evidence-links-empty" colspan="5">
																				<div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
																			</td>
																		</tr>
																	</tbody>
																</table>
															</div>
														</div>
														<pagination
															v-if="filteredLinkCount > 0"
															:dynamicPagination="filteredLinkCount"
															:sortedData="sortedLinkEvidences"
															@currentPageUpdate="onLinkPaginationUpdate"
														/>
													</div>
													</div>
													</div>
												</div>
											</div>
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 5">
												<div>
													<div class="border-b border-lightgrey flex justify-between pb-2 mt-3">
														<div class="flex items-center justify-center">
															<div>
																<p class="header">Comments</p>
															</div>
														</div>
														<div>
															<div class="buttonposition flex justify-center items-center">
																<div class="buttonposition flex justify-center items-center">
																	<button class="filterButton w-24 flex " v-if="oldComments" @click="sortComments()">
																		<img src="@/assets/sortBy.svg" class="h-3 mr-2.5" />
																		Oldest
																	</button>
																	<button class="filterButton w-24 flex " v-if="!oldComments" @click="sortComments()">
																		<img src="@/assets/sortBy.svg" class="h-3 mr-2.5 rotate-180" />
																		Newest
																	</button>
																</div>
															</div>
														</div>
													</div>
													<div>
														<div class="comment-box w-full mt-5">
															<!-- <div class="my-3"><textarea placeholder="Add a Comment" class="w-full text-xs border border-lightgrey rounded-sm p-2" rows="4" :disabled="TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417 || presentAuditObject.statusCode == 10403|| presentAuditObject.statusCode == 10418" v-model="comment" @input="handleInput"></textarea></div> -->
															<commentsEditor v-if="TaskDetailsDropDown.taskStatus!=10403  && TaskDetailsDropDown.taskStatus!=10418 && TaskDetailsDropDown.taskStatus!=10417 && isAddDisabled(10302)" :taskStatusCode="TaskDetailsDropDown.taskStatus"/>
															<!-- <div class="flex justify-end">
																<button @click="addComment" class="mr-2" :class="{ btnprimary: !btnDisabled, btndisabled: btnDisabled }" :disabled="btnDisabled">Add</button>
																<button @click="clearComment" :class="{ btnprimary: !btnDisabled, btndisabled: btnDisabled }" :disabled="btnDisabled">Cancel</button>
															</div> -->
														</div>
														<div v-if="Object.keys(presentTaskObject).includes('comments')" class="comments">
															<div v-for="(obj, index) in presentTaskObject.comments" class="border border-lightgrey mt-2 rounded-sm flex flex-row p-3" :key="index">
																<div class="initials">{{extractInitials((obj.name) )}}</div>
																<div class="w-1/5">
																	<div class="header">{{ obj.name }}</div>
																	<div class="fontSize10PX">{{ obj.createdAt }}</div>
																</div>
																<div class="w-4/5 text-xs text-justify">
																	<safeHtml :content="obj.comment"/>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 6">
												<div>
													<div class="border-b border-lightgrey flex justify-between pb-2 mt-3">
														<div class="flex items-center justify-center">
															<div>
																<p class="header">Findings</p>
															</div>
														</div>
														<div>
															<div class="buttonposition flex justify-center items-center">
																<button @click="showFindingPopup()" :class="isFindingEditDisabled() ? 'btndisabled pointer-events-none' : 'filterButton flex justify-center '" class="w-32 flex justify-center " >Add Findings</button>
															</div>
														</div>
													</div>
													<div>
														<div class="text-xs pt-3">
															<!-- Result of the evaluation of the collected audit evidence against audit criteria . Audit findings indicate conformity or nonconformity . Audit findings can lead to the identification of risks , opportunities for improvement or recording good practices. -->
														</div>
														<div  v-if="findingsForTask.length > 0" class="">
															<div v-for="(obj, index) in findingsForTask" :key="obj._id || index" class="mt-4 relative" :class="canOpenFinding(obj) ? 'cursor-pointer' : ''" @click="openExistingFinding(obj)">
																<button
																	v-if="!isFindingEditDisabled()"
																	type="button"
																	class="absolute top-2 right-2 z-10 p-1 rounded hover:bg-gray-100"
																	title="Delete finding"
																	@click.stop="openDeleteFindingConfirm(obj)"
																>
																	<img src="@/assets/deleteIcon.svg" class="h-4 w-4" alt="Delete" />
																</button>
																<div class="flex flex-row">
																		<div class="border-t border-l border-b p-2 header w-23 border-lightgrey rounded-tl-md">Finding ID</div>
																		<div  class="border header border-lightgrey w-77 p-2 rounded-tr-md">
																			{{obj.findingId}}
																		</div>
																	</div>
																	<div class="w-full flex flex-row">
																			<div class="border-l w-23 border-b p-2 header border-lightgrey">Framework</div>
																			<div  class="w-27 border-b border-l border-lightgrey text-xs p-2">
																					<div class="mt-1">{{obj.frameworks}}</div>
																				</div>
																			<div class="border-l w-23 border-b p-2 header border-lightgrey">Control Number</div>
																				<div  class="border-r w-27 border-b border-l border-lightgrey p-2">
																					<div class="pl-3 flex items-center flex-wrap">
																						<div v-if="obj.frameWorkControl != undefined" :class="getBorder()" class="text-xs px-2 py-0.5 font-opensans bg-white font-bold h-auto w-fit flex items-center" >
																							{{obj.frameWorkControl}}
																						</div>
																					</div>
																				</div>
																	</div>
																	<div class="flex flex-row">
																		<div class="border-l border-b p-2 header w-23 border-lightgrey">Control Title</div>
																		<div class="border-r border-b border-l border-lightgrey w-77 text-xs p-2">{{ obj.frameworkControlTitle ? obj.frameworkControlTitle : 'N/A' }}</div>
																	</div>
																	<div class="flex flex-row">
																		<div class="border-l border-b p-2 header w-23 border-lightgrey">Finding</div> <div  class="border-r border-b border-l border-lightgrey w-77 p-2 text-xs">{{ obj.findingComment }}</div>
																	</div>
																	<div class="flex flex-row">
																		<div class="border-l border-b p-2 header w-23 border-lightgrey">Finding Severity</div>
																		<div class="border-r border-b border-l border-lightgrey w-77 p-2 text-xs flex items-center">
																			<div
																				v-if="getFindingSeverityValue(obj) != null"
																				class="flex items-center justify-center rounded h-5 w-28 px-2.5 regular whitespace-nowrap overflow-hidden"
																				:class="findingSeverityChipBg(obj)"
																				:title="getFindingSeverityLabel(obj)"
																			>
																				<div class="truncate whitespace-nowrap" :class="findingSeverityChipText(obj)">
																					{{ getFindingSeverityLabel(obj) }}
																				</div>
																			</div>
																			<span v-else>N/A</span>
																		</div>
																	</div>
																	<div class="flex flex-row">
																		<div class="border-l border-b p-2 header w-23 border-lightgrey">Evidence</div>
																		<div class=" flex border-r border-b border-l border-lightgrey w-77 p-2">
																			<div v-for="doc,index in obj.findingEvidence" :key="index">
																				<p v-if="obj.findingEvidence!=undefined && obj.findingEvidence.length>0" class="ml-0.5 text-xs"> {{evidenceDisplayName(doc)}}     
																				 	<span v-if="index < obj.findingEvidence.length - 1">,</span>
																				</p>
																				<p v-else class="border-r border-b border-l border-lightgrey">N/A</p>
																			</div>
																		</div>
																	</div>
																	<div class="w-full flex flex-row">
																			<div class="border-l w-23 border-b p-2 header border-lightgrey rounded-bl-md">Finding Category</div>
																			<div  class="w-27 border-b border-l border-lightgrey  p-2">
																					<div v-if="obj.findingCategory === 1" class="flex items-center justify-center rounded w-28 h-5 text-error bg-highColor border-solid border text-xs border-error p-1 font-semibold">{{getCategory(obj.findingCategory)}}</div>
																					<div v-else-if="obj.findingCategory === 2" class="flex items-center justify-center rounded w-28 h-5 text-darkred bg-veryHighColor border-solid border text-xs border-darkred p-1 font-semibold">{{getCategory(obj.findingCategory)}}</div>
																					<div v-else-if="obj.findingCategory === 3" class="flex items-center justify-center rounded w-28 h-5 text-lightgreen bg-veryLowColor border-solid border text-xs border-lightgreen p-1 font-semibold">{{getCategory(obj.findingCategory)}}</div>
																					<div v-else-if="obj.findingCategory === 4" class="flex items-center justify-center rounded w-28 h-5 text-yellow bg-moderateColor border-solid border text-xs border-yellow p-1 font-semibold">{{getCategory(obj.findingCategory)}}</div>
																					<div v-else class="text-xs">N/A</div>
																			</div>
																			<div class="border-l w-23 border-b p-2 header border-lightgrey">Control Audit Result</div>
																					<div class="border-r w-27 border-b border-l border-lightgrey p-2 rounded-br-md">
																						<div v-if="obj.auditResult === 'Pass'" class="flex items-center justify-center rounded h-5 w-28 text-lightgreen bg-veryLowColor text-xs border-solid border border-lightgreen font-semibold">{{obj.auditResult}}</div>
																						<div v-else-if="obj.auditResult === 'Fail'" class="flex items-center justify-center rounded h-5 w-28 text-darkred bg-veryHighColor text-xs border-solid border border-darkred font-semibold">{{obj.auditResult}}</div>
																						<div v-else class="text-xs">N/A</div>
																					</div>
																		</div>
																	
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 7">
												<div>
													<div class="border-b border-lightgrey flex justify-between pb-2 mt-3">
														<div class="flex items-center justify-center">
															<div>
																<p class="header">History</p>
															</div>
														</div>
														<div>
															<div class="buttonposition flex justify-center items-center">
																<div class="buttonposition flex justify-center items-center">
																	<button class="filterButton w-24 flex " v-if="newHistory" @click="sortWorkLog()">
																		<img src="@/assets/sortBy.svg" class="h-3 mr-2.5" />
																		Oldest
																	</button>
																	<button class="filterButton w-24 flex " v-if="!newHistory" @click="sortWorkLog()">
																		<img src="@/assets/sortBy.svg" class="h-3 mr-2.5 rotate-180" />
																		Newest
																	</button>
																</div>
															</div>
														</div>
													</div>

												<div v-for="work in workLogObject.taskHistory" :key="work" class="bg-white py-4 mb-0.5 border-lightgrey border-b w-full">
														<div class="flex">
															<div v-if="Object.keys(work).includes('createdBy')" class="initials">
																{{ extractInitials(work.name) }}
															</div>
															<div v-if="Object.keys(work).includes('updatedBy')" class="initials">
																{{ extractInitials(work.name) }}
															</div>
															<div class="logContainer w-93">
																<div class="flex mt-1">
																	<p v-if="Object.keys(work).includes('createdBy')" class="font-semibold text-xs">
																		{{work.name }}
																	</p>
																	<p v-else-if="Object.keys(work).includes('updatedBy')" class="font-semibold text-xs">
																		{{ work.name }}
																	</p>
			
																	<p v-if="work.actionEntity == 10301" class="mx-2 text-xs">{{ 'Created the Task on' }}</p>
																	<p v-else-if="work.statusCode != undefined && work.statusCode == 10418" class="mx-2 text-xs">{{ 'Terminated the Task on' }}</p>
																	<p v-else-if="work.actionEntity == 10302 && !Object.keys(work.additionalInfo).includes('previousDueDate')" class="mx-2 text-xs">{{ 'Updated the Task on' }}</p>
																	<p v-else-if="work.actionEntity == 10302 && Object.keys(work.additionalInfo).includes('previousDueDate')" class="mx-2 text-xs">{{ 'Updated the Due Date at' }}</p>
		
																	<p v-if="Object.keys(work).includes('createdAt')" class="font-semibold  text-xs">{{ formatTime(work.createdAt) }}</p>
																	<p v-if="Object.keys(work).includes('updatedAt')" class="font-semibold text-xs">{{ formatTime(work.updatedAt) }}</p>
																</div>
																<div class="mt-3" v-if="Object.keys(work).includes('additionalInfo')">
																	<div class="flex" v-if="Object.keys(work.additionalInfo).includes('comment')">
																		<p class="font-semibold text-xs widthForCommentBox">{{ 'Comment :' }}</p>
																		<p class="text-xs w-full text-justify">
																			<safeHtml :content="work.additionalInfo.comment"/>
																		</p>
																	</div>
																	<div class="flex" v-if="Object.keys(work.additionalInfo).includes('findingId')">
																		<p class="font-semibold text-xs">{{'Added the finding -'}}</p>
																		<p class="mx-2 text-xs">{{ work.additionalInfo.findingId }}</p>
																	</div>
																	<div class="flex" v-if="Object.keys(work.additionalInfo).includes('updatedFindingId')">
                                                                        <p class="font-semibold text-xs">{{'Updated the finding -'}}</p>
                                                                        <p class="mx-2 text-xs">{{ work.additionalInfo.updatedFindingId }}</p>
                                                                    </div>
																	<div class="flex" v-if="Object.keys(work.additionalInfo).includes('deletedFindingId')">
																		<p class="font-semibold text-xs">{{'Removed the finding -'}}</p>
																		<p class="mx-2 text-xs">{{ work.additionalInfo.deletedFindingId }}</p>
																	</div>
                                                                    <div class="flex mt-2" v-for="file in (work.additionalInfo.addedAttachments || [])" :key="'added-' + file">
                                                                        <p class="font-semibold text-xs">{{'Attached -'}}</p>
                                                                        <p class="mx-2 text-xs">{{ file }}</p>
                                                                    </div>
                                                                    <div class="flex mt-2" v-for="file in (work.additionalInfo.removedAttachments || [])" :key="'removed-' + file">
                                                                        <p class="font-semibold text-xs">{{'Removed the attachment -'}}</p>
                                                                        <p class="mx-2 text-xs">{{ file }}</p>
                                                                    </div>
                                                                    <div class="flex items-center mt-2" v-for="change in (work.additionalInfo.changes || [])" :key="change.field">
                                                                        <p class="font-semibold text-xs shrink-0 whitespace-nowrap">{{ change.field }}</p>
                                                                        <template v-if="change.field === 'Finding Severity'">
                                                                            <div
                                                                                class="mx-2 flex items-center justify-center rounded h-5 w-28 px-2.5 regular overflow-hidden"
                                                                                :class="findingSeverityChipBg({ findingSeverity: change.previous })"
                                                                                :title="getFindingSeverityHistoryLabel(change.previous)"
                                                                            >
                                                                                <div class="truncate whitespace-nowrap" :class="findingSeverityChipText({ findingSeverity: change.previous })">
                                                                                    {{ getFindingSeverityHistoryLabel(change.previous) }}
                                                                                </div>
                                                                            </div>
                                                                            <div class="mx-2 flex items-center shrink-0"><img src="@/assets/arrowRight.svg" class="shrink-0"/></div>
                                                                            <div
                                                                                class="flex items-center justify-center rounded h-5 w-28 px-2.5 regular overflow-hidden"
                                                                                :class="findingSeverityChipBg({ findingSeverity: change.updated })"
                                                                                :title="getFindingSeverityHistoryLabel(change.updated)"
                                                                            >
                                                                                <div class="truncate whitespace-nowrap" :class="findingSeverityChipText({ findingSeverity: change.updated })">
                                                                                    {{ getFindingSeverityHistoryLabel(change.updated) }}
                                                                                </div>
                                                                            </div>
                                                                        </template>
                                                                        <template v-else>
                                                                            <p class="mx-2 text-xs">{{ change.previous || 'N/A' }}</p>
                                                                            <div class="mx-2 flex items-center"><img src="@/assets/arrowRight.svg"/></div>
                                                                            <p class="text-xs">{{ change.updated || 'N/A' }}</p>
                                                                        </template>
                                                                    </div>

																	<div class="flex" v-if="Object.keys(work.additionalInfo).includes('evidence') && !work.additionalInfo.removed">
																		<p class="font-semibold text-xs">{{'Uploaded the Evidence -'}}</p>
																		<p class="mx-2 text-xs">{{ work.additionalInfo.evidence }}</p>
																	</div>
																	<div class="flex" v-if="work.additionalInfo.removed">
																		<p class="font-semibold text-xs">{{'Deleted the Evidence -'}}</p>
																		<p class="mx-2 text-xs">{{ work.additionalInfo.evidence }}</p>
																	</div>
																	<div class="flex" v-if="Object.keys(work.additionalInfo).includes('linkedEvidenceTitles')">
																		<p class="font-semibold text-xs">{{'Linked the Evidence -'}}</p>
																		<p class="mx-2 text-xs">{{ work.additionalInfo.linkedEvidenceTitles }}</p>
																	</div>
																	<div class="flex mt-2" v-if="Object.keys(work.additionalInfo).includes('linkedEvidenceDates')">
																		<p class="font-semibold text-xs">{{'Linked Evidence Date -'}}</p>
																		<p class="mx-2 text-xs">{{ work.additionalInfo.linkedEvidenceDates }}</p>
																	</div>
																	<div class="flex mt-2" v-if="Object.keys(work.additionalInfo).includes('evidenceDate')">
																		<p class="font-semibold text-xs">{{'Evidence Date -'}}</p>
																		<p class="mx-2 text-xs">{{ formatDate(work.additionalInfo.evidenceDate)||'N/A' }}</p>
																		<p class="font-semibold text-xs">{{'to'}}</p>
																	</div>
																	<div class="flex mt-2" v-if="Object.keys(work.additionalInfo).includes('evidenceDate')">
																		<p class="mx-2 text-xs">{{ formatDate(work.additionalInfo.evidenceDate)||'N/A' }}</p>
																	</div>
																	<div class="flex mt-2" v-if="Object.keys(work.additionalInfo).includes('previousDueDate')">
																		<p class="font-semibold text-xs">{{'from '}}</p>
																		<p class="mx-2 text-xs">{{ formatDate(work.additionalInfo.previousDueDate)||'N/A' }}</p>
																		<p class="font-semibold text-xs">{{'to'}}</p>
																		<p class="mx-2 text-xs">{{ formatDate(work.additionalInfo.updatedDueDate)||'N/A' }}</p>
																	</div>
																	<div class="flex" v-if="Object.keys(work.additionalInfo).includes('assignee')">
																		<p class="font-semibold text-xs">{{'Assigned the Task To -'}}</p>
																		<p class="mx-2 text-xs">{{ getPersonName(work.additionalInfo.assignee) }}</p>
																	</div>
																	<div class="flex items-center" v-if="Object.keys(work.additionalInfo).includes('previousStatus')">
																		<div>
																			<p class="font-semibold text-xs">{{'Updated The Status :'}}</p>
																		</div>
																		<div class="flex ml-4">
																			<div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorAuditBg(work.additionalInfo.previousStatus)">
																				<div :class="colorAuditText(work.additionalInfo.previousStatus)">
																					{{ getStatusLabel(work.additionalInfo.previousStatus) }}
																				</div>
																			</div>
																			<div class="mx-4 flex items-center"><img src="@/assets/arrowRight.svg"/></div>
																			<div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorAuditBg(work.additionalInfo.updatedStatus)">
																				<div :class="colorAuditText(work.additionalInfo.updatedStatus)">
																					{{ getStatusLabel(work.additionalInfo.updatedStatus) }}
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</TabPanel>
								</TabPanels>
							</Tabs>
						</div>
						<div class="w-20 border taskDetailsRightBar rounded-sm border-lightgrey">
							<div class="m-3">
								<div class="pb-2 border-b border-lightgrey">
									<h1>Task Details</h1>
								</div>
								<div v-if="tabDataLoading == true">
									<div class="flex items-center justify-center w-full h-16 skeleton">
									<dots-loader/>
									</div>
								</div>
								<div v-else class="pt-1.5 overflow-y-scroll thirtyWidthToggle">
									<div class="flex flex-col mb-3">
										<label class="controllabel">Task Status</label>
										<input disabled v-if="TaskDetailsDropDown.taskStatus == 10418" type="text" placeholder="Status" class="terminateBox inputboxstyling mt-2" value="Terminated" />
										<input disabled v-else-if="TaskDetailsDropDown.taskStatus == 10403" type="text" placeholder="Status" class="completedBox inputboxstyling mt-2" value="Completed" />
										<input disabled v-else-if="TaskDetailsDropDown.taskStatus == 10417" type="text" placeholder="Status" class="bg-darkred textColorWhite inputboxstyling mt-2" value="Not Applicable" />
										<div v-else>
											<!-- <select
												class="mt-2 custom-select cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey"
												:class="changeBackground()"
												:disabled="TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417 || presentAuditObject.statusCode == 10403|| presentAuditObject.statusCode == 10418 || TaskDetailsDropDown.taskStatus == 10418"
												v-model="TaskDetailsDropDown.taskStatus"
												@change="updateTaskStatus(TaskDetailsDropDown.taskStatus)"
											>
												<option value="" selected disabled hidden>Please select one</option>
												<option v-for="i in filteredTaskStatusData" :value="i.id" :key="i"  :disabled="i.id == 10401" :class="i.id == 10401 ? 'taskStatusOptionsForNotStarted' : 'taskStatusOptions'">
													{{ i.status }}
												</option>
											</select> -->
											<Select 
												:key="statusSelectKey"
												v-model="TaskDetailsDropDown.taskStatus"
												:options="filteredTaskStatusData"
												:disabled="TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417 || presentAuditObject.statusCode == 10403|| presentAuditObject.statusCode == 10418 || TaskDetailsDropDown.taskStatus == 10418 || !isAddDisabled(10302)"
												optionLabel="status"     
												optionValue="id"        
												placeholder="Please select one"
												class="w-full mt-2 custom-select cursor-pointer text-sm font-light rounded-sm border border-lightgrey my-task-status-select selectIcon accessDisabledColor"
												:class="changeBackground()"
												@change="updateTaskStatus(TaskDetailsDropDown.taskStatus)"
												:optionDisabled="isOptionDisabled"
											/>
										</div>
										<!-- <select
											class="custom-select cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey"
											v-else
											:disabled="presentAuditObject.statusCode == 10418 || TaskDetailsDropDown.taskStatus == 10418"
											v-model="TaskDetailsDropDown.taskStatus"
										>
											<option value="" selected disabled hidden>Please select one</option>
											<option v-for="i in terminateArray" :value="i.id" :key="i">
												{{ i.status }}
											</option>
										</select> -->

									</div>
		
									
									<div>
										<div>
											<label class="controllabel">Assigned To</label>
											<div class="mt-2 mb-3" v-if="TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417 || presentAuditObject.statusCode == 10403|| presentAuditObject.statusCode == 10418 || presentTaskObject.auditor == userInfo._id || (presentTaskObject.auditee != userInfo._id && presentAssignee == userInfo._id)">{{presentTaskObject.assignee != undefined ? presentTaskObject.assignee.label : 'N/A'}}</div>
											<div v-else>
												<!-- <multiselect
												v-model="presentTaskObject.assignee"
												:options="userOptions"
												:showNoOptions="false"
												@search-change="asyncFind"
												:limit-text="limitText"
												:multiple="false"
												:close-on-select="true"
												:clear-on-select="true"
												label="label"
												open-direction="bottom"
												:hide-selected="true"
												track-by="value"   
												@select="updateAssignedMember(presentTaskObject.assignee)" 
												:searchable="true"
												:hideArrow="false"
												placeholder="Assigned-To"
												deselectLabel=""
												selectLabel=""
												class="custom-multiselect userSelect mt-2 mb-3"
												:class="{
													'has-options': userOptions && userOptions.length > 0,
													'no-options': !userOptions.length &&  searchValue !== '',
												}"
											>
												<template v-slot:noResult>
													<span class="text-xs">No Members Found</span>
												</template>
										    	</multiselect> -->
												<AutoComplete
													appendTo="body"
													v-model="presentTaskObject.assignee"
													:suggestions="userOptions"
													optionLabel="label"
													placeholder="Assigned-To"
													class="w-full custom-multiselect userSelect mt-2"
													:class="{
														'has-options': userOptions && userOptions.length > 0,
														'no-options': !userOptions.length && searchValue !== '',
													}"
													@complete="asyncFind"
													@item-select="onAssigneeSelect"
												/>


											</div>
										</div>
									</div>
									<div class="mt-3">
                                        <label class="controllabel">Due Date</label><br>
										<div>
											<input
												type="date"
												v-model="presentTaskObject.dueDate"
												class="mt-2 w-full stylingForInputboxstylingForSelectAtPopup"
												@focus="openCalendar"
												onkeydown="return false"
												placeholder="Select Date"
												:disabled="TaskDetailsDropDown.taskStatus ==10403||TaskDetailsDropDown.taskStatus ==10418"
												@change="updateTaskDueDate(6,presentTaskObject.dueDate)"
											/>
										</div>
                                    </div>
									<div class="mt-3">
                                        <label class="controllabel">Auditor</label><br>
										<div class="my-1 mt-2 text-sm" v-if="presentTaskObject.auditor != undefined || presentTaskObject.auditor != null">{{ getPerson(presentTaskObject.auditor) }}</div>
										<p class="mt-2 text-sm" v-else>N/A</p>
                                    </div>
                                    <div class="mt-3">
                                        <label class="controllabel">Auditee</label><br>
										<div class="my-1 mt-2 text-sm" v-if="presentTaskObject.auditee != undefined || presentTaskObject.auditee != null">{{ getPersonName(presentTaskObject.auditee) }}</div>
										<p class="mt-2 text-sm" v-else>N/A</p>
                                    </div>
                                    <div class="mt-3">
                                        <label class="controllabel">Team</label><br>
										<div class="my-1 mt-2 text-sm" v-if="presentTaskObject.department != undefined || presentTaskObject.department != null">{{ getTeamName(presentTaskObject.department) }}</div>
										<p class="mt-2 text-sm" v-else>N/A</p>
                                    </div>
									<div class="mt-3">
                                        <label class="controllabel">Location</label><br>
										<div class="my-1 mt-2 text-sm" v-if="presentTaskObject.department != undefined || presentTaskObject.department != null">{{ getLocationName(presentTaskObject.department) }}</div>
										<div class="my-1 mt-2 text-sm" v-else>{{'N/A'}}</div>
										<!-- <p class="mt-2 text-sm" v-else>N/A</p> -->
                                    </div>
									<div class="mt-3">
                                        <label class="controllabel">Tier</label><br>
										<div class="my-1 mt-2 text-sm">{{getTierDetails(presentTaskObject).tier}}</div>
										<!-- <p class="mt-2 text-sm" v-else>N/A</p> -->
                                    </div>
									<div class="mt-3">
                                        <label class="controllabel">Scope</label><br>
										<div class="my-1 mt-2 text-sm">{{ getTierDetails(presentTaskObject).tierInfo}}</div>
										<!-- <div class="my-1 mt-2 text-sm" v-else>{{'N/A'}}</div> -->
										<!-- <p class="mt-2 text-sm" v-else>N/A</p> -->
                                    </div>

								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<popup v-if="importpopUp" :popUp="importpopUp">
			<div class="overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex">
			<div class="relative w-full max-w-xl">
			<!--content-->
			<div class="border-0 rounded relative flex flex-col w-full bg-white h-screen">
				<!--header-->
				<div class="flex items-center justify-between popupheadingcontainer rounded">
				<h1>{{ evidenceAttachMode === 'url' ? 'Attach Link' : 'Attach File' }}</h1>
				<button class="p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none" @click="onCancelIcon()">
					<img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
				</button>
				</div>
				<div class="border-b border-solid border-lightgrey ml-4 mr-4"></div>
				<div class="flex-1 overflow-auto">
				<div class="impactcontainer popupbodycontainer">
				<div class="formcontainer flex flex-col">
					<div class="row flex flex-col mt-2">
					<div>
						<label class="controllabel">{{ evidenceAttachMode === 'url' ? 'Title' : 'File Name' }} </label>
						<input class="inputboxstyling text-xs mt-2" type="text" v-model.trim="inputFileName" :placeholder="evidenceAttachMode === 'url' ? 'Evidence title' : 'Filename'"  :class="{'is-invalid': v$.inputFileName.$error }" @input="v$.inputFileName.$touch()"/>
						<div v-if="v$.inputFileName.$error " class="text-red-500">
							<div class="error-text text-xs" v-if="v$.inputFileName.required.$invalid ">Required</div>
							<div v-else-if="(v$.inputFileName.restrictCharacters50 && v$.inputFileName.restrictCharacters50.$invalid) || (v$.inputFileName.restrictCharacters60 && v$.inputFileName.restrictCharacters60.$invalid)" class="error-text text-xs">Charcter Limit is exceeded</div>
						</div>
					</div>
					<div class="pt-3" v-if="evidenceAttachMode === 'file'">
						<label class="controllabel">Attachment</label>
						<input
						type="file"
						ref="fileInput"
						class="hidden"
						id="upload"
						@change="handleFileUpload"
						/>
						<div 
						class="w-auto rounded-sm mt-2 p-8
								flex flex-col items-center justify-center text-center transition
								border-2 border-dashed border-lightgrey bg-whitegrey"
						:class="{
							'is-invalid': v$.fileToUpload.$error || pdfValidation,
							'border-primary': isDragOver
						}"
						@dragenter.prevent="onDragOver"
						@dragover.prevent="onDragOver"
						@dragleave.prevent="onDragLeave"
						@drop.prevent="onFileDrop"
						>
						<img
							src="@/assets/fileUploadIcon.svg"
							class="h-10 w-10 mb-3"
							alt="Upload file"
						/>

						<p v-if="fileName === ''" class="text-sm font-semibold text-darkblue mb-4">
							Drag and drop your file here
						</p>
						<p v-else class="text-sm font-semibold text-primary mb-4">
							{{ fileName }}
						</p>
						<div class="flex items-center justify-center gap-2">
							<label for="upload" class="cursor-pointer">
							<span class="btnprimary text-xs gap-1">
								<img src="@/assets/Browse.svg" class="h-4 w-4" alt="" />
								Browse
							</span>
							</label>

							<button
							type="button"
							class="filterButton text-xs gap-1"
							:class="fileName === '' ? 'filterButtondisabled pointer-events-none' : ''"
							:disabled="fileName === ''"
							@click="clearSelectedFile"
							>
							Cancel
							</button>
						</div>
						</div>
						<div class="min-h-[22px] text-red-500">
						<div
							v-if="v$.fileToUpload.$invalid && !pdfValidation && (v$.fileToUpload.$error || pdfValidation)"
							class="error-text text-xs"
						>
							File upload is required
						</div>
						<div
							v-if="pdfValidation && !v$.fileToUpload.$invalid"
							class="text-red-500 text-xs"
						>
							This File Format is not Supported
						</div>
						</div>
						<div class="mt-2 flex flex-col items-center">
						<p class="text-xs text-placeholder">
						Accepted Formats: PDF, JPG, PNG, ZIP, TXT, XLS, DOC, MP4
						</p>
						<p class="text-xs text-placeholder mt-1">
						Maximum File Size: 50 MB
						</p>
						</div>
              		</div>
					<div class="pt-3" v-if="evidenceAttachMode === 'url'">
						<label class="controllabel">URL</label>
						<input
							class="inputboxstyling text-xs mt-2"
							type="url"
							v-model.trim="evidenceUrl"
							placeholder="URL"
							@input="v$.evidenceUrl.$touch()"
							:class="{'is-invalid': v$.evidenceUrl.$error }"
						/>
						<div v-if="v$.evidenceUrl.$error" class="text-red-500">
							<div class="error-text text-xs" v-if="v$.evidenceUrl.required.$invalid">Required</div>
							<div class="error-text text-xs" v-else-if="v$.evidenceUrl.httpUrl.$invalid">URL must use http or https</div>
						</div>
					</div>
					<div class="pt-3 w-1/2">
						<label class="controllabel">Evidence Date</label>
						<input
							v-model="evidenceDate"
							type="date"
							class="mt-2 w-full inputboxstylingForSelectAtPopup"
							@focus="openCalendar"
							style="height:28px"
							onkeydown="return false"
							:class="{
								'inputboxstylingForSelectAtPopup': evidenceDate === '',
								'stylingForInputboxstylingForSelectAtPopup': evidenceDate !== '',
								'is-invalid':v$.evidenceDate.$error
								}"
							
							placeholder="Select Date"
							:max="todayDate"

						/>
						<div v-if="v$.evidenceDate.$error" class="text-red-500">
							<div v-if="v$.evidenceDate.$invalid" class="error-text text-xs">Evidence date is required</div>
						</div>
					</div>
					</div>
				</div>
				</div>
				</div>
				<div>
					<div class="border-b border-solid border-lightgrey mx-5"></div>
					<div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
						<button @click="handleFileChange" :class="isEvidenceSaveDisabled ? 'btndisabled pointer-events-none ' : 'btnprimary'" :disabled="clickOnButton">Save</button>
					</div>
				</div>
			</div>
			</div>
			</div>
		</popup>
		<popup v-if="showPopUp" :popUp="showPopUp">
			<div class="overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex">
			<div class="relative w-full max-w-xl">
			<div class="border-0 rounded relative flex flex-col w-full bg-white h-screen">
				<div class="flex items-center justify-between m-4 rounded">
					<h1>Findings</h1>
					<button class="float-right text-3xl" @click="onCancelButtonAddPopUp()">
						<img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
					</button>
				</div>
			<div class="border-b border-solid border-lightgrey ml-4 mr-4"></div>
			<div class="flex-1 overflow-auto ">
				<div class="impactcontainer popupbodycontainer">
					<div class="statuscontainer">
						<div class="formcontainer flex flex-col">
						<div class="row flex flex-row w-full mt-3 mb-3">
							<div class="w-1/2 pr-2">
								<label class="controllabel">Finding-Id</label>
								<input type="text" v-model.trim="findingsObject.findingId" disabled class="inputboxstyling mt-2"/>
								<div v-if="v$.findingsObject.findingId.$error" class="text-red-500">
									<div class="error-text" v-if="v$.findingsObject.findingId.required.$invalid">Required</div>
								</div>
							</div>
							<div class="w-1/2 pl-2">
								<label class="controllabel">Finding Category</label>
								<!-- <select class="mt-2 cursor-pointer" v-model="findingsObject.findingCategory" :class="{ 'is-invalid': v$.findingsObject.findingCategory.$error,'inputboxstylingForSelectAtPopup': findingsObject.findingCategory === '','stylingForInputboxstylingForSelectAtPopup': findingsObject.findingCategory !== ''}" @change="updateAuditResult">
									<option value="" selected disabled hidden>Please select one</option>
									<option v-for="i in findingCategoryData" :value="i.id" :key="i.id">
										{{ i.value }}
									</option>
								</select> -->
								<Select 
									appendTo="body"
									v-model="findingsObject.findingCategory"
									:options="findingCategoryData"
									optionLabel="value"     
									optionValue="id"        
									placeholder="Please select one"
									class="w-full mt-2 custom-select cursor-pointer text-sm font-light rounded-sm border border-lightgrey"
									:class="{
										'is-invalid': v$.findingsObject.findingCategory.$error,
										'inputboxstylingForSelectAtPopup': findingsObject.findingCategory === '',
										'stylingForInputboxstylingForSelectAtPopup': findingsObject.findingCategory !== ''
									}"
									@change="updateAuditResult"
								/>

								<div v-if="v$.findingsObject.findingCategory.$error" class="text-red-500">
									<div class="error-text" v-if="v$.findingsObject.findingCategory.required.$invalid">Required</div>
								</div>
							</div>
						</div>
						<div class="row flex flex-row w-full mb-3">
							<div class="w-1/2 pr-2">
								<label class="controllabel">Framework</label>
								<!-- <select class="mt-2 cursor-pointer" @change="changeFrameWorkControlNums()" v-model="findingsObject.frameworks" :class="{ 'is-invalid': v$.findingsObject.frameworks.$error,'inputboxstylingForSelectAtPopup': findingsObject.frameworks === '','stylingForInputboxstylingForSelectAtPopup': findingsObject.frameworks !== ''}">
									<option value="" selected hidden>Please select one</option>
									<option v-for="i in auditFrameworkArray" :value="i" :key="i">
										{{ i }}
									</option>
								</select> -->
								<Select 
									appendTo="body"
									v-model="findingsObject.frameworks"
									:options="auditFrameworkArray"
									       
									placeholder="Please select one"
									class="w-full mt-2 custom-select cursor-pointer text-sm font-light rounded-sm border border-lightgrey"
									:class="{
										'is-invalid': v$.findingsObject.frameworks.$error,
										'inputboxstylingForSelectAtPopup': findingsObject.frameworks === '',
										'stylingForInputboxstylingForSelectAtPopup': findingsObject.frameworks !== ''
									}"
									@change="changeFrameWorkControlNums()"
								/>

								<div v-if="v$.findingsObject.frameworks.$error" class="text-red-500">
									<div class="error-text" v-if="v$.findingsObject.frameworks.required.$invalid">Required</div>
								</div>
							</div>
							<div class="w-1/2 pl-2">
								<label class="controllabel">Control</label>
								<Select 
									appendTo="body"
									v-model="findingsObject.frameWorkControl"
									:options="selectedFrameworkControls"
									optionLabel="controlNumber"
									optionValue="controlNumber"
									:disabled="findingsObject.frameworks == ''"  
									placeholder="Please select one"
									class="w-full mt-2 custom-select cursor-pointer text-sm font-light rounded-sm border border-lightgrey"
									:class="{
										'is-invalid': v$.findingsObject.frameWorkControl.$error,
										'inputboxstylingForSelectAtPopup': findingsObject.frameWorkControl === '',
										'stylingForInputboxstylingForSelectAtPopup': findingsObject.frameWorkControl !== ''
									}"
									@change="bindSelectedControlTitle"
								/>
								<div v-if="v$.findingsObject.frameWorkControl.$error" class="text-red-500">
									<div class="error-text" v-if="v$.findingsObject.frameWorkControl.required.$invalid">Required</div>
								</div>
							</div>
						</div>
						<div class="w-full mb-3">
							<label class="controllabel">Control Title</label>
							<input class="inputboxstyling mt-2 disabled:bg-[#e9e9e9] disabled:text-[#a4a4a4] disabled:border-[#e9e9e9] disabled:cursor-not-allowed disabled:hover:bg-[#e9e9e9] disabled:focus:bg-[#e9e9e9]" disabled v-model="findingsObject.frameworkControlTitle" type="text" placeholder="Control Title" :class="{ 'is-invalid': v$.findingsObject.frameworkControlTitle.$error }" />
							<div v-if="v$.findingsObject.frameworkControlTitle.$error" class="text-red-500">
								<div class="error-text" v-if="v$.findingsObject.frameworkControlTitle.required.$invalid">Required</div>
							</div>
						</div>
						<div class="row flex flex-row w-full mb-3">
							<div class="w-1/2 pr-2">
								<label class="controllabel">Finding Severity</label>
								<Select
									appendTo="body"
									v-model="findingsObject.findingSeverity"
									:options="controlRiskSeverityLabelOptions"
									optionLabel="key"
									optionValue="value"
									placeholder="Please select one"
									class="w-full mt-2 custom-select cursor-pointer text-sm font-light rounded-sm border border-lightgrey"
									:class="{
										'is-invalid': v$.findingsObject.findingSeverity.$error,
										'inputboxstylingForSelectAtPopup': findingsObject.findingSeverity === '',
										'stylingForInputboxstylingForSelectAtPopup': findingsObject.findingSeverity !== ''
									}"
								/>
								<div v-if="v$.findingsObject.findingSeverity.$error" class="text-red-500">
									<div class="error-text" v-if="v$.findingsObject.findingSeverity.required.$invalid">Required</div>
								</div>
							</div>
						</div>
						<div class="w-full mb-3">
							<label class="controllabel">Findings</label>
							<textarea v-model.trim="findingsObject.findingComment" class="inputboxstyling mt-2 resize-none" placeholder="Findings" rows="3" :class="{ 'is-invalid': v$.findingsObject.findingComment.$error }"></textarea>
							<div v-if="v$.findingsObject.findingComment.$error" class="text-red-500">
								<div class="error-text" v-if="v$.findingsObject.findingComment.required.$invalid">Required</div>
							</div>
						</div>
						<div class="w-full mb-3">
							<label class="controllabel">Evidence</label>
							<!-- <textarea v-model="findingsObject.findingEvidence" class="inputboxstyling resize-none" placeholder="Finding related to Evidence" :class="{ 'is-invalid': v$.findingsObject.findingEvidence.$error }"></textarea> -->
							<!-- <multiselect
								v-model="findingsObject.findingEvidence"
								:options="evidenceArray"
								:show-labels="false"
								:multiple="false"
								:hide-selected="true"
								open-direction="bottom"
								:searchable="true"
								:hideArrow="false"
								placeholder="Evidences"
								class="custom-multiselect userSelect mt-2"
								:class="{'is-invalidmultiselect': v$.findingsObject.findingEvidence.$error}"
							>
								<template v-slot:noResult>
									<span class="text-xs">No Evidences Found</span>
								</template>
							</multiselect> -->
							<MultiSelect
								v-model="findingsObject.findingEvidence"
								:options="evidenceArray"
								optionLabel="filename"
								optionValue="value"
								dataKey="value"
								placeholder="Evidences"
								:filter="true"
								class="w-full custom-multiselect userSelect mt-2 md:w-[530px] lg:w-[530px]"
								:class="{'p-invalid': v$.findingsObject.findingEvidence.$error}"
							>
							<template #empty>
								<span class="text-xs">No Evidences Found</span>
							</template>
							</MultiSelect>
							<div v-if="v$.findingsObject.findingEvidence.$error" class="text-red-500">
								<div class="error-text" v-if="v$.findingsObject.findingEvidence.required.$invalid">Required</div>
							</div>
						</div>
						<div class="w-1/2 mt-3 mb-3">
							<label class="controllabel">Control Audit Result</label>
							<input class="inputboxstyling mt-2 cursor-pointer" disabled v-model="findingsObject.auditResult" type="text" placeholder="Result" />
							<!-- <div v-if="v$.findingsObject.auditResult.$error" class="text-red-500">
								<div class="error-text" v-if="v$.findingsObject.auditResult.required.$invalid">Required</div>
							</div> -->
						</div>
						</div>
					</div>
				</div>
			</div>
			<div>
				<div class="border-b border-solid border-lightgrey mx-5"></div>
				<div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
					<button class="mr-2" :class="(JSON.stringify(findingsObject) != JSON.stringify(findingsObjectDummy)) ? 'btnprimary' : 'btndisabled pointer-events-none'" @click="onCancelbtn()">Cancel</button>
					<button v-if="!findingsObject._id" :class="(JSON.stringify(findingsObject) != JSON.stringify(findingsObjectDummy)) ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButtonForFinding" @click="saveEnteredFinding()">Save</button>
					<button v-else :class="(JSON.stringify(findingsObject) != JSON.stringify(findingsObjectDummy)) ? 'btnprimary' : 'btndisabled pointer-events-none'" :disabled="clickOnButtonForFinding" @click="saveEnteredFinding()">Update</button>
				</div>
			</div>
			</div>
			</div>
			</div>
				
		</popup>
		<div v-if="showCompleteFindingsDialog" class="completeFindingsDialog fixed inset-0 flex items-center justify-center">
			<div class="absolute inset-0 bg-black opacity-40" @click="cancelCompleteWithFindings"></div>
			<div class="completeFindingsCard relative bg-white rounded-md shadow-lg">
				<div class="flex items-start">
					<div class="mr-3 h-10 w-10 rounded-full bg-[#FFE8D6] flex items-center justify-center shrink-0">
						<img src="@/assets/warning.svg" class="h-6 w-6" alt="" />
					</div>
					<div>
						<h1 class="text-base font-semibold text-black">Mark task as Completed?</h1>
						<p class="text-sm text-gray mt-2">Findings will no longer be editable.</p>
					</div>
				</div>
				<div class="completeFindingsActions flex justify-end">
					<button class="completeFindingsCancel mr-2" @click="cancelCompleteWithFindings">Cancel</button>
					<button class="btnprimary" @click="confirmCompleteWithFindings">Confirm</button>
				</div>
			</div>
		</div>
		<div v-if="showDeleteFindingConfirm" class="completeFindingsDialog fixed inset-0 flex items-center justify-center">
			<div class="absolute inset-0 bg-black opacity-40" @click="cancelDeleteFinding"></div>
			<div class="completeFindingsCard relative bg-white rounded-md shadow-lg">
				<div class="flex items-start">
					<div class="mr-3 h-10 w-10 rounded-full bg-[#FFE8D6] flex items-center justify-center shrink-0">
						<img src="@/assets/warning.svg" class="h-6 w-6" alt="" />
					</div>
					<div>
						<h1 class="text-base font-semibold text-black">Delete finding?</h1>
						<p class="text-sm text-gray mt-2">Finding {{ findingPendingDelete?.findingId }} will be removed from this task.</p>
					</div>
				</div>
				<div class="completeFindingsActions flex justify-end">
					<button class="completeFindingsCancel mr-2" @click="cancelDeleteFinding">Cancel</button>
					<button class="btnprimary" @click="confirmDeleteFinding">Delete</button>
				</div>
			</div>
		</div>
		<div v-if="showDeleteEvidenceConfirm" class="evidence-delete-confirm">
			<div class="evidence-delete-backdrop" @click="cancelDeleteEvidence"></div>
			<div class="evidence-delete-dialog">
				<div class="evidence-delete-dialog-title">
					<div class="evidence-delete-warning">
						<img src="@/assets/warning.svg" class="evidence-delete-warning-icon" alt="" />
					</div>
					<span>Delete Evidence</span>
				</div>
				<p class="evidence-delete-dialog-message">Are you sure you want to delete this evidence?</p>
				<div class="evidence-delete-dialog-actions">
					<button type="button" class="evidence-delete-cancel" @click="cancelDeleteEvidence">Cancel</button>
					<button type="button" class="evidence-delete-ok" @click="confirmDeleteEvidence">OK</button>
				</div>
			</div>
		</div>
		<div v-if="linkEvidencePopup" class="link-existing-confirm">
			<div class="link-existing-backdrop" @click="closeLinkEvidencePopup"></div>
			<div class="link-existing-dialog">
				<div class="link-existing-title">
					<span class="link-existing-warning" aria-hidden="true">
						<img src="@/assets/warning.svg" class="link-existing-warning-icon" alt="" />
					</span>
					<span>Link Existing Evidence</span>
				</div>
				<p class="link-existing-message">Select evidence from the past year listed below.</p>
				<div class="link-existing-tables">
					<div class="link-existing-section-row">
						<div class="link-existing-section">EXISTING EVIDENCE ({{ filteredSortedExistingEvidences.length }})</div>
						<button type="button" class="filterButton flex" @click="toggleExistingEvidenceFilters">
							<img src="@/assets/filter.svg" class="filterIcon" />
							Filters
						</button>
					</div>
					<div class="link-existing-table-wrap" :class="{ 'link-existing-table-wrap--empty': filteredSortedExistingEvidences.length === 0 }">
						<table class="link-existing-table">
							<thead>
								<tr>
									<th class="link-existing-col-check"></th>
									<th class="cursor-pointer" @click="sortExistingEvidence('filename')">
										<div class="flex table-header-label-wrap">
											<div class="table-header-label">TITLE</div>
											<div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'filename' ? existingEvidenceSortClass : 'opacity-50'"></div>
										</div>
									</th>
									<th class="cursor-pointer" @click="sortExistingEvidence('sourceTaskId')">
										<div class="flex table-header-label-wrap">
											<div class="table-header-label">TASK ID</div>
											<div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'sourceTaskId' ? existingEvidenceSortClass : 'opacity-50'"></div>
										</div>
									</th>
									<th class="cursor-pointer" @click="sortExistingEvidence('evidenceType')">
										<div class="flex table-header-label-wrap">
											<div class="table-header-label">TYPE</div>
											<div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'evidenceType' ? existingEvidenceSortClass : 'opacity-50'"></div>
										</div>
									</th>
									<th class="cursor-pointer" @click="sortExistingEvidence('evidenceDate')">
										<div class="flex table-header-label-wrap">
											<div class="table-header-label">EVIDENCE DATE</div>
											<div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'evidenceDate' ? existingEvidenceSortClass : 'opacity-50'"></div>
										</div>
									</th>
								</tr>
								<tr v-if="showExistingEvidenceFilters" class="link-existing-filter-row">
									<td class="link-existing-col-check"></td>
									<td><input type="text" class="searchForInputBoxStyling" v-model.trim="existingEvidenceFilters.filename" placeholder="Search" @click.stop /></td>
									<td><input type="text" class="searchForInputBoxStyling" v-model.trim="existingEvidenceFilters.sourceTaskId" placeholder="Search" @click.stop /></td>
									<td><input type="text" class="searchForInputBoxStyling" v-model.trim="existingEvidenceFilters.evidenceType" placeholder="Search" @click.stop /></td>
									<td></td>
								</tr>
							</thead>
							<tbody v-if="filteredSortedExistingEvidences.length">
								<tr v-for="row in filteredSortedExistingEvidences" :key="row.optionKey">
									<td class="link-existing-col-check">
										<input type="checkbox" :checked="isExistingEvidenceSelected(row)" @change="toggleExistingEvidence(row)" />
									</td>
									<td :title="row.filename">{{ row.filename }}</td>
									<td>{{ row.sourceTaskId }}</td>
									<td>{{ existingEvidenceTypeLabel(row) }}</td>
									<td>{{ row.evidenceDate ? formatFileAttachedTime(row.evidenceDate) : 'N/A' }}</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
									<td class="link-existing-empty" colspan="5">No Records Found</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="link-existing-actions">
					<button type="button" class="link-existing-cancel" @click="closeLinkEvidencePopup">Cancel</button>
					<button type="button" class="link-existing-save" @click="saveLinkedEvidence" :class="selectedExistingEvidences.length === 0 ? 'link-existing-save-disabled' : ''">Save</button>
				</div>
			</div>
		</div>
		<div v-if="toolTipActive">
			<tool-tip :tipText="toolTipText"></tool-tip>
		</div>
	</div>
</template>
<style scoped>
.completeFindingsDialog {
	z-index: 11100;
}
.completeFindingsCard {
	width: 448px;
	height: 148px;
	box-sizing: border-box;
	padding: 16px 24px 0;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.completeFindingsActions {
	margin-left: -24px;
	margin-right: -24px;
	padding: 10px 24px;
	border-top: 1px solid #E9E9E9;
}
.completeFindingsCancel {
	height: 1.75rem;
	padding-left: 1.25rem;
	padding-right: 1.25rem;
	border-radius: 0.25rem;
	border: 1px solid #d0d0d0;
	background-color: #ffffff;
	color: #4d4d4d;
	font-size: 0.875rem;
	font-weight: 600;
	cursor: pointer;
}
.widthForCommentBox{
	width : 75px;
}
.bgdarkred{
 background-color: rgba(192, 0, 0, 0.2);
}
.heightForDiv{
height : 29.333px;
padding-left: 0.625rem;
padding-right: 0.625rem;
padding-top: 0.25rem;
padding-bottom: 0.25rem;
}
.w-80{
	width: 80%;
}
.w-20{
	width: 20%;
}
.selectIcon :deep(.p-select-dropdown){
	display: none;
}
.textColorWhite,.textColorWhite:hover{
	color: white;
}
:deep(.p-select.p-disabled.bg-disabledgrey),.bg-disabledgrey,.p-select.bg-disabledgrey.p-focus{
  background-color: #a4a4a4 !important;
  border:1px solid #a4a4a4 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-yellow),.bg-yellow,.p-select.bg-yellow.p-focus{
  background-color: #FF9900 !important;
  border:1px solid #FF9900 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-forReview),.bg-forReview,.p-select.bg-forReview.p-focus{
  background-color: #085B96 !important;
  border:1px solid #085B96 !important;
  font-weight: 600 !important;
}
.p-select.p-disabled .p-select-dropdown{
  background-color: #a4a4a4 !important;
}
:deep(.accessDisabledColor.p-select.p-disabled .p-select-label) {
  color: #ffffff !important;
}
:deep(.p-select.p-disabled.bg-electricGreen),.bg-electricGreen,.p-select.bg-electricGreen.p-focus{
  background-color: #8600F0 !important;
  border:1px solid #8600F0 !important;
  font-weight: 600 !important;
}
:deep(.p-select.pendingEvidence-status),
.pendingEvidence-status,
.p-select.pendingEvidence-status.p-focus,
:deep(.p-select.p-disabled.pendingEvidence-status) {
  background-color: #8600F0 !important;
  border: 1px solid #8600F0 !important;
  font-weight: 600 !important;
}
:deep(.my-task-status-select.pendingEvidence-status .p-select-label),
:deep(.p-select.pendingEvidence-status .p-select-label) {
  color: #ffffff !important;
}
:deep(.p-select.p-disabled.bg-lightgreen),.bg-lightgreen,.p-select.bg-lightgreen.p-focus{
  background-color: #00B050 !important;
  border:1px solid #00B050 !important;
  font-weight:600 !important;
}
:deep(.p-select.p-disabled.bg-darkred),.bg-darkred,.p-select.bg-darkred.p-focus{
  background-color: #C00000 !important;
  border:1px solid #C00000 !important;
  font-weight:600 !important;
}
:deep(.p-select.p-disabled.bg-error),.bg-error,.p-select.bg-error.p-focus{
  background-color: #FF0000 !important;
  border:1px solid #FF0000 !important;
  font-weight:600 !important;
}
:deep(.p-select.p-disabled.bg-primary),.bg-primary,.p-select.bg-primary.p-focus{
  background-color: #1976D2 !important;
  border:1px solid #1976D2 !important;
  font-weight:600 !important;
}
:deep(.my-task-status-select .p-select-label) {
  color: white !important;
}

:deep(.my-task-status-select .p-select.p-disabled .p-select-label){
  color: white !important;
}
:deep(.my-task-status-select .p-select.p-disabled .p-select-dropdown) {
  display: none !important;
}
.taskStatusOptions{
  background-color: white; 
  color: rgba(77, 77, 77, var(--tw-text-opacity))
 }
 .taskStatusOptionsForNotStarted{
    background-color: #e9e9e9; 
  color: rgba(77, 77, 77, var(--tw-text-opacity))
 }
.completedBox{
	background-color: #00B050 !important;
	font-weight:600 !important;
	color: white;
	pointer-events: none;
}
.terminateBox{
	background-color: #FF0000 !important;
	color: white;
	pointer-events: none;
}
.progressbarB {
	border: 2px solid #e9e9e9;
	background: #e9e9e9;
	position: relative;
	top: -8px;
	z-index: 1;
}
.numberBorder{
    border-top: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
}
.numberNavy{
    border-left: 1px solid #152A43;
    border-width: 2px;
}
.progress {
	background: #1976d2;
	position: relative;
	border-radius: 4px;
	z-index: 2;
}
.primaryBackground{
	background-color: #1976d233
}
.descriptionToggle {
	height: 97%;
}
.tabStructure {
	height: calc(100vh - 165px);
}
.thirtyWidthToggle::-webkit-scrollbar {
	width: 0 !important;
	height: 0 !important;
	background: transparent;
}

.thirtyWidthToggle::-webkit-scrollbar-thumb {
	background: transparent;
}
.thirtyWidthToggle{  
     height:  calc(100vh - 250px);
}
.descriptionToggle::-webkit-scrollbar {
	width: 0 !important;
	height: 0 !important;
	background: transparent;
}

.descriptionToggle::-webkit-scrollbar-thumb {
	background: transparent;
}
.heightFixing {
	height:  calc(100vh - 220px);
	/* height : 64vh; */
}
.task-details-in-modal .descriptionToggle,
.task-details-in-modal .thirtyWidthToggle {
	overflow-y: auto !important;
	scrollbar-width: thin;
	scrollbar-color: #a4a4a4 transparent;
}
.task-details-in-modal .descriptionToggle::-webkit-scrollbar,
.task-details-in-modal .thirtyWidthToggle::-webkit-scrollbar {
	width: 6px !important;
	height: 6px !important;
	display: block !important;
	background: transparent !important;
}
.task-details-in-modal .descriptionToggle::-webkit-scrollbar-track,
.task-details-in-modal .thirtyWidthToggle::-webkit-scrollbar-track {
	background: transparent !important;
}
.task-details-in-modal .descriptionToggle::-webkit-scrollbar-thumb,
.task-details-in-modal .thirtyWidthToggle::-webkit-scrollbar-thumb {
	background: #a4a4a4 !important;
	border-radius: 4px;
}
option {
	background-color: #ffffff;
	color: #000000;
	border-color: pink transparent transparent transparent;
}
.textColorWhite {
	color: white;
}
.custom-select {
    background-image: url("../assets/Collapse.svg") !important;
    background-repeat: no-repeat no-repeat;
    background-position: center center;
    background-size: 12px 12px;
    background-position: right 15px center; /* Change the px value here to change the distance */
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
}
.marginBottomForDoc{
	margin-bottom : 3px;
}
.marginTopForDoc{
	margin-top : 2.5px;
}
.marginBottomZero{
	margin-bottom : 0px;
}
.pendingEvidence{
    background-color: #8600f040;
}
.pendingEvidenceFill{
    background-color: #8600F0;
}
.evidenceUpload{
    background: rgba(25,118,210,0.24);
}
.labelWidth{
	min-width: 7rem;
}
.framework{
	padding: 12px 170px 12px 12px;
}
.findingCategory{
	padding: 12px 80px 12px 12px;
}
.btnprimary1 {
	cursor: pointer;
	border-bottom-right-radius: 0.25rem;
	border-top-right-radius: 0.25rem;
	--tw-bg-opacity: 1;
	background-color: rgba(21, 42, 67, var(--tw-bg-opacity));
	padding-left: 0.625rem;
	padding-right: 0.625rem;
	padding-top: 0.625rem;
	padding-bottom: 0.625rem;
	/* font-family: Open Sans; */
	font-size: 0.875rem;
	/* line-height: 1.25rem; */
	font-weight: 700;
	/* line-height: 0.75rem; */
	--tw-text-opacity: 1;
	color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.evidenceHeight{
	height: 29px;
}
 @media only screen and (min-width: 320px) and  (max-width: 850px) {
    :deep(.p-tablist-tab-list){
      width: max-content !important;

    }
  }
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import breadCrumbs from '@/components/breadCrumbs.vue';
import {helpers,required, requiredIf } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import popup from '@/components/popup.vue';
import tableData from '@/components/tableData.vue';
import toolTip from '@/components/toolTip.vue';
import { groupBy } from 'lodash';
import { emitter, toast } from '@/main';
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { v4 as uuidv4 } from 'uuid';
import commentsEditor from '@/components/commentsEditor.vue';
import Multiselect from 'vue-multiselect';
import safeHtml from "@/components/safeHtml.vue";
import dotsLoader from '@/components/dotsLoader.vue';
import pagination from '@/components/pagination.vue';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import Select from 'primevue/select';
import AutoComplete from 'primevue/autocomplete';
import MultiSelect from 'primevue/multiselect';

const restrictCharacters20 = helpers.regex(/^.{0,20}$/);
const restrictCharacters50 = helpers.regex(/^.{0,50}$/);
const restrictCharacters60 = helpers.regex(/^.{0,60}$/);
const httpUrl = (value: string) => {
	if (!value) return true;
	try {
		const parsed = new URL(value);
		return parsed.protocol === 'http:' || parsed.protocol === 'https:';
	} catch {
		return false;
	}
};

export default defineComponent({
	props: {
		auditId: { type: [String, Number], default: null },
		taskId: { type: [String, Number], default: null },
		myTasks: { type: [Boolean, String], default: null },
		modalMode: { type: Boolean, default: false },
	},
	emits: ['header-info', 'open-nested'],
	data(): any {
		return {
			v$: useVuelidate(),
			fileToUpload: null,
			selectedTabIndex: 1,
			tabHead: [
				{ displayName: 'Description', id: 1 },

				{ displayName: 'Documents', id: 2 },

				{ displayName: 'Related Tasks', id: 3 },

				{ displayName: 'Evidence', id: 4 },

				{ displayName: 'Comments', id: 5 },

				{ displayName: 'Findings', id: 6 },

				{ displayName: 'History', id: 7 }
			],
			routesArray: [],
			Headers: ['TaskId','Title','Frequency','dueDate','statusCode'],
			selectedFrameworkControls:[],
			taskFrameworkControls:[],
			tableRow: [],
			TaskDetailsDropDown: {
				taskStatus: '',
				assignedToDropDown: ''
			},
			tabDataLoading:false,
			userOptions:[],
			evidenceArray:[],
			optionSystemArray:[],
			optionsActivityArray:[],
			assignedToList:[],
			terminateArray:[
				{
					id: 10418,
					status: 'Terminated'
				},
			],
			taskStatusData: [],
			findingCategoryData: [
				{
					id: 4,
					value: 'Observation'
				},
				{
					id: 3,
					value: 'OFI'
				},
				{
					id: 1,
					value: 'Minor'
				},
				{
					id: 2,
					value: 'Major'
				}
			],

			assignedToData: [
				{
					id: 1,
					name: 'Nikhil Kapuganti'
				},
				{
					id: 2,
					name: 'Abhiram Kadari'
				},
				{
					id: 3,
					name: 'Venkatesh Abisetty'
				}
			],
			oldComments: true,
			newHistory: true,
			comment: '',
			comments: [],
			btnDisabled: true,
			showPopUp: false,
			showCompleteFindingsDialog: false,
			statusSelectKey: 0,
			auditFrameworkArray: [],
			findingsObject: {
				findingId:'',
				frameworks: '',
				frameWorkControl:'',
				frameworkControlTitle: '',
				findingCategory: '',
				findingSeverity: '',
				findingComment: '',
				findingEvidence: '',
				auditResult: ''
			},
			controlRiskSeverityLabelOptions: [],
			findingsObjectDummy: {},
			presentAuditData: {},
			selectedOption: '',
			selectedBG: '',
			workLogObject: [],
			optionsUserArray: [],
			orgUsersList: [],
			presentAuditObject: {},
			tasksForAudit: [],
			presentTaskObject: {},
			dummyPresentTaskObject:{},
			personObj : '',
			controlsArray : [],
			controlDetailsArray : [],
            controlsArrayAllControls : [],
            controlsDetailsList : [],
			teamObj : '',
            selectedTabObj:{},
            users : [],
			allFrameWorkControls:[],
			locationObject:[],
			importpopUp: false,
			evidenceAttachMode: 'file',
			evidenceUrl: '',
			linkSortKey: '',
			linkSortDir: 'asc',
			linkCurrentPage: 1,
			linkPageSize: 10,
			isInputFileNameValid: true,
			fileSelected: false,
			isFileValid: true,
			inputFileName: '',
			fileChanged : false,
			fileName:'',
			evidenceDate:'',
			findingsForTask:[],
			evidenceOptions:[],
			presentAssignee:'',
			TeamLeaderValue:'',
			clickOnButton:false,
			clickOnButtonForFinding:false,
			searchValue:'',
			TeamReviewerValue:'',
			placeholder: 'Select a File',
			disabledStatuses:[],
			toolTipActive: false,
			toolTipText: '',
			showDeleteFindingConfirm: false,
			findingPendingDelete: null,
			showDeleteEvidenceConfirm: false,
			deleteEvidenceIndex: null,
			linkEvidencePopup: false,
			linkEvidenceTasks: [],
			selectedExistingEvidences: [],
			existingEvidenceSortKey: '',
			existingEvidenceSortDir: 'asc',
			showExistingEvidenceFilters: false,
			existingEvidenceFilters: { filename: '', sourceTaskId: '', evidenceType: '', evidenceDate: '' },
		};
	},
	validations() {
		return {
			inputFileName:{
				required,
				restrictCharacters50: function (this: any, value: string) {
					if (this.evidenceAttachMode !== 'file') return true;
					return restrictCharacters50(value);
				},
				restrictCharacters60: function (this: any, value: string) {
					if (this.evidenceAttachMode !== 'url') return true;
					return restrictCharacters60(value);
				}
			},
			fileToUpload: {
				required: requiredIf(function (this: any) {
					return this.evidenceAttachMode === 'file';
				})
			},
			evidenceUrl: {
				required: requiredIf(function (this: any) {
					return this.evidenceAttachMode === 'url';
				}),
				httpUrl
			},
			evidenceDate:{required},
			findingsObject: {
				findingId:{required},
				frameworks: { required },
				frameWorkControl:{required},
				frameworkControlTitle:{required},
				findingCategory: { required },
				findingSeverity: { required },
				findingComment: { required },
				findingEvidence: { required }
				// auditResult: { required }
			}
		};
	},
	components: {
		breadCrumbs,
		popup,
		Multiselect,
		tableData,
		toolTip,
		commentsEditor,
		safeHtml,
		dotsLoader,
		pagination,
		Tabs,
		Tab,
		TabList,
		TabPanels,
		TabPanel,
		Select,
		AutoComplete,
		MultiSelect
	},
	computed: {
		...mapGetters({ userInfo: 'userInfo',dbFrequency:'dbFrequency',dbPriority:'dbPriority' }),
		currentAuditId(): any {
			return this.auditId || this.$route.params.auditId || this.presentAuditObject?._id || this.presentTaskObject?.auditId;
		},
		currentTaskId(): any {
			return this.taskId || this.$route.params.taskId || this.presentTaskObject?._id;
		},
		isEvidenceSaveDisabled(): boolean {
			if (this.evidenceAttachMode === 'url') {
				return this.inputFileName.length === 0 && this.evidenceUrl.length === 0 && this.evidenceDate.length === 0;
			}
			return this.inputFileName.length === 0 && this.evidenceDate.length === 0;
		},
		fileEvidences(): any[] {
			const files = this.presentTaskObject?.files;
			if (!Array.isArray(files)) return [];
			return files.filter((doc: any) => (doc?.evidenceType || 'file') !== 'url');
		},
		linkEvidences(): any[] {
			const files = this.presentTaskObject?.files;
			if (!Array.isArray(files)) return [];
			return files.filter((doc: any) => doc?.evidenceType === 'url');
		},
		pastYearExistingEvidences(): any[] {
			const currentId = String(this.currentTaskId || '');
			const currentUrls = new Set((this.presentTaskObject?.files || []).map((doc: any) => doc?.url).filter((url: any) => !!url));
			const userId = String(this.userInfo?._id || '');
			const now = new Date();
			const oneYearAgo = new Date();
			oneYearAgo.setFullYear(now.getFullYear() - 1);
			const rows: any[] = [];
			const seen = new Set<string>();
			const originalOwnerByUrl = new Map<string, string>();
			(this.linkEvidenceTasks || []).forEach((task: any) => {
				if (!Array.isArray(task?.files)) return;
				task.files.forEach((doc: any) => {
					if (!doc?.url || doc.linkedEvidenceTaskId == null || String(doc.linkedEvidenceTaskId) === '') return;
					originalOwnerByUrl.set(String(doc.url), String(doc.linkedEvidenceTaskId));
				});
			});
			(this.linkEvidenceTasks || []).forEach((task: any) => {
				if (String(task?._id || '') === currentId || !Array.isArray(task?.files)) return;
				const sourceTaskId = task.taskId != null && String(task.taskId) !== '' ? String(task.taskId) : '';
				if (!sourceTaskId) return;
				task.files.forEach((doc: any) => {
					if (!doc?.url || currentUrls.has(doc.url)) return;
					if (doc.taskId != null && String(doc.taskId) !== '' && String(doc.taskId) !== sourceTaskId) return;
					if (doc.linkedEvidenceTaskId != null && String(doc.linkedEvidenceTaskId) !== '') return;
					const originalOwner = originalOwnerByUrl.get(String(doc.url));
					if (originalOwner && originalOwner !== sourceTaskId) return;
					if (String(doc.createdBy || '') !== userId) return;
					const filename = doc.filename || doc.name;
					if (!filename) return;
					const evidenceTime = Date.parse(doc.evidenceDate);
					if (isNaN(evidenceTime) || evidenceTime < oneYearAgo.getTime() || evidenceTime > now.getTime()) return;
					const optionKey = `${sourceTaskId}|${doc.url}`;
					if (seen.has(optionKey)) return;
					seen.add(optionKey);
					rows.push({
						...doc,
						filename,
						sourceTaskId,
						optionKey
					});
				});
			});
			return rows;
		},
		existingEvidenceSortClass(): string {
			return this.existingEvidenceSortDir === 'asc' ? 'sort_desc' : 'sort_asc';
		},
		filteredSortedExistingEvidences(): any[] {
			const filters = this.existingEvidenceFilters || {};
			const rows = (this.pastYearExistingEvidences || []).filter((row: any) => {
				const title = String(row.filename || '').toLowerCase();
				const taskId = String(row.sourceTaskId || '').toLowerCase();
				const typeLabel = this.existingEvidenceTypeLabel(row).toLowerCase();
				if (filters.filename && !title.includes(String(filters.filename).toLowerCase())) return false;
				if (filters.sourceTaskId && !taskId.includes(String(filters.sourceTaskId).toLowerCase())) return false;
				if (filters.evidenceType && !typeLabel.includes(String(filters.evidenceType).toLowerCase())) return false;
				return true;
			});
			const key = this.existingEvidenceSortKey;
			if (!key) return rows;
			const modifier = this.existingEvidenceSortDir === 'desc' ? -1 : 1;
			return rows.sort((a: any, b: any) => {
				if (key === 'evidenceDate') {
					const aTime = Date.parse(a?.evidenceDate);
					const bTime = Date.parse(b?.evidenceDate);
					if (aTime < bTime) return -1 * modifier;
					if (aTime > bTime) return 1 * modifier;
					return 0;
				}
				if (key === 'sourceTaskId') {
					const aVal = String(a?.sourceTaskId || '');
					const bVal = String(b?.sourceTaskId || '');
					const aNumMatch = aVal.match(/\d+$/);
					const bNumMatch = bVal.match(/\d+$/);
					if (aNumMatch && bNumMatch) {
						const aNum = parseInt(aNumMatch[0], 10);
						const bNum = parseInt(bNumMatch[0], 10);
						if (aNum < bNum) return -1 * modifier;
						if (aNum > bNum) return 1 * modifier;
						return 0;
					}
					if (aVal < bVal) return -1 * modifier;
					if (aVal > bVal) return 1 * modifier;
					return 0;
				}
				const aVal = key === 'evidenceType' ? this.existingEvidenceTypeLabel(a) : String(a?.filename || '');
				const bVal = key === 'evidenceType' ? this.existingEvidenceTypeLabel(b) : String(b?.filename || '');
				if (aVal.toLowerCase() < bVal.toLowerCase()) return -1 * modifier;
				if (aVal.toLowerCase() > bVal.toLowerCase()) return 1 * modifier;
				return 0;
			});
		},
		linkSortClass(): string {
			return this.linkSortDir === 'asc' ? 'sort_desc' : 'sort_asc';
		},
		sortedLinkEvidences(): any[] {
			const rows = [...this.linkEvidences];
			const key = this.linkSortKey;
			if (!key) {
				return rows;
			}
			const dir = this.linkSortDir === 'asc' ? 1 : -1;
			return rows.sort((a: any, b: any) => {
				let aVal = '';
				let bVal = '';
				if (key === 'evidenceDate') {
					aVal = a?.evidenceDate || '';
					bVal = b?.evidenceDate || '';
				} else if (key === 'url') {
					aVal = a?.url || '';
					bVal = b?.url || '';
				} else if (key === 'taskId') {
					aVal = a?.taskId || '';
					bVal = b?.taskId || '';
				} else {
					aVal = a?.filename || a?.name || '';
					bVal = b?.filename || b?.name || '';
				}
				return String(aVal).localeCompare(String(bVal), undefined, { sensitivity: 'base' }) * dir;
			});
		},
		filteredLinkCount(): number {
			return this.sortedLinkEvidences.length;
		},
		paginatedLinkEvidences(): any[] {
			const start = (this.linkCurrentPage - 1) * this.linkPageSize;
			const end = this.linkCurrentPage * this.linkPageSize;
			return this.sortedLinkEvidences.slice(start, end);
		},
		linkTableResizeStyle(): any {
			return {
				tableLayout: 'fixed',
				width: '100%',
				maxWidth: '100%',
			};
		},
		isMyTasks(): any {
			return this.myTasks === true || this.myTasks === 'true' || Object.keys(this.$route.query || {}).includes('myTasks');
		},
		filteredTaskStatusData: function ():any {
			return this.taskStatusData.filter((i:any) => {
				if(this.userInfo?.organisationType==10702){										
    			return !((i.id == 10403 || i.id == 10417) && (this.TeamReviewerValue != this.userInfo._id && (this.userInfo.roleId == 10216)));
				}
				else if(this.userInfo?.organisationType==10701){					
					return !((i.id == 10403 || i.id == 10417) && this.userInfo.role_id==10216);
				}
			});
		},
		todayDate() {
			return new Date().toISOString().split('T')[0];
		},
	},
	watch: {
		presentTaskObject: {
			handler(obj: any) {
				if (this.modalMode && obj && (obj.controlTitle || obj.taskId)) {
					this.$emit('header-info', { title: obj.controlTitle || obj.taskId });
				}
			},
			deep: true,
		},
	},
	methods: {
		limitText (count:any) {
			// return `and ${count} other countries`
			// console.log('countcount',count)
		},
		async updateTaskDueDate(type:any,dueDate:any){
			console.log('11',type,dueDate);
			let now = new Date();
            let selectedDate = new Date(dueDate);
            selectedDate.setHours(
                now.getHours(),
                now.getMinutes(),
                now.getSeconds(),
                now.getMilliseconds()
            );
			let payload:any={dueDate:selectedDate}
			await this.updateAuditTask(8,payload)
			
		},
		filterOpen() {
			this.showFilters = !this.showFilters;
			emitter.emit('visible', this.showFilters);
		},
		onActivateToolTip(data: any) {
			this.toolTipActive = true;
			this.toolTipText = data.tipText;
		},
		onDeactivateToolTip() {
			this.toolTipActive = false;
			this.toolTipText = '';
		},
		openCalendar(event: any) {
			event.target.showPicker();
		},
		formatDate(time: any) {
			if(time!=''){
				return moment(time).format("DD-MM-YYYY");
			}
			else {
				return 'N/A'
			}
		},
		asyncFind(query:any){
			query=query.query
			this.searchValue = query;
			if(query == ''){
				this.userOptions = []
			}else if(query.length > 0){
				this.userOptions = this.assignedToList.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase()) && obj.value != this.presentTaskObject.auditor})
			}
		},
		
		formatFileAttachedTime(time: any) {    
			let now = moment(time);
			return now.format("DD-MM-YYYY");
		},
		getS3KeyFromUrl(fileUrl: string) {
			try {
				const url = new URL(fileUrl);
				return url.pathname.startsWith('/')
				? url.pathname.slice(1)
				: url.pathname;
			} catch (e) {
				return '';
			}
		},

		getEvidenceFileExt(doc: any) {
			if (!doc?.url || doc.evidenceType === 'url') return '';
			try {
				const path = new URL(doc.url).pathname;
				return (path.split('.').pop() || '').toLowerCase();
			} catch {
				return (String(doc.url).split('.').pop() || '').toLowerCase();
			}
		},
		async openEvidenceFile(doc: any) {
			const fileUrl = typeof doc === 'string' ? doc : doc?.url;
			if (!fileUrl) return;

			if (typeof doc !== 'string' && doc?.evidenceType === 'url') {
				window.open(fileUrl, '_blank', 'noopener,noreferrer');
				return;
			}

			const key = this.getS3KeyFromUrl(fileUrl);
			if (!key) {
				return;
			}

			try {
				const response = await this.$http.post(
				`${process.env.VUE_APP_FILE_API}/presignedurl/v3`,
				{ key }
				);

				const signedUrl =
				typeof response.data === 'string'
					? response.data
					: response.data?.url;

				if (signedUrl) {
				window.open(signedUrl, '_self');
				}
			} catch (err) {
				console.error(err);
			}
		},
		sortLinkEvidences(key: string) {
			if (this.linkSortKey === key) {
				this.linkSortDir = this.linkSortDir === 'asc' ? 'desc' : 'asc';
			} else {
				this.linkSortKey = key;
				this.linkSortDir = 'asc';
			}
			this.linkCurrentPage = 1;
		},
		onLinkPaginationUpdate(currentPage: any, pageSize: any) {
			this.linkCurrentPage = currentPage;
			this.linkPageSize = pageSize;
		},
		 colorForDueDate(date: any) {
			if (!date) return '';
			const due = new Date(date);
			if (isNaN(due.getTime())) return '';
			const today = new Date();
			due.setHours(0, 0, 0, 0);
			today.setHours(0, 0, 0, 0);

			if (due < today) {
			return ["bgdarkred border-solid border text-darkred font-semibold flex justify-center items-center text-xs"]
			}
			return '';
		},
		isFindingEditDisabled() {
			const statusLocked = this.TaskDetailsDropDown.taskStatus == 10401
				|| this.TaskDetailsDropDown.taskStatus == 10403
				|| this.TaskDetailsDropDown.taskStatus == 10417
				|| this.presentAuditObject.statusCode == 10403
				|| this.presentAuditObject.statusCode == 10418;
			const notAssignedAuditor = this.presentTaskObject?.auditor !== this.userInfo?._id
				&& this.userInfo?.organisationType != 10701;
			return statusLocked || (notAssignedAuditor && !this.isAddDisabled(10302));
		},
		canOpenFinding(finding: any) {
			return !!(finding && finding._id && finding.findingId && finding.findingId !== 'N/A' && !this.isFindingEditDisabled());
		},
		openDeleteFindingConfirm(obj: any) {
			if (this.isFindingEditDisabled()) {
				return;
			}
			this.findingPendingDelete = obj;
			this.showDeleteFindingConfirm = true;
		},
		cancelDeleteFinding() {
			this.showDeleteFindingConfirm = false;
			this.findingPendingDelete = null;
		},
		async confirmDeleteFinding() {
			const finding = this.findingPendingDelete;
			this.showDeleteFindingConfirm = false;
			this.findingPendingDelete = null;
			if (!finding?.findingId) {
				return;
			}
			await this.updateAuditTask(10, { findingId: finding.findingId });
		},
		isAddDisabled(permission:any) {
			try {
				if (!this.userInfo || !this.userInfo.organisationType) {
					return true;
				}
				// if (this.userInfo.organisationType !== 10701) {
				// 	return true; 
				// }
				return this.hasPermission(this.userInfo, 10006, 10121, permission);
			} catch (e) {
				return true;
			}
	  	},
		hasPermission(userInfo:any, appId:any, entityId:any, permissionId:any) {
			if (!userInfo || !userInfo.apps) return false;
			const app = userInfo.apps.find((a:any) => a.appId === appId);
			if (!app) return false;

			const entity = app.entities?.find((e:any) => e.entityId === entityId);
			if (!entity) return false;

			return entity.permissions?.includes(permissionId) || false;
		},
		async getAllBusinessProcesses() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${20006}`).then((result: any) => {
				this.allProcess = result.data
            });
			for(let i=0;i<this.allProcess.length;i++){
				this.optionsActivityArray.push({ label: this.allProcess[i].businessProcessName, value: this.allProcess[i]._id });
			}
		},
		async getAllSystems(){
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${20005}`).then((result: any) => {
				this.allSystems = result.data;
				// this.orgUsersList = res.data
				for (var i = 0; i < this.allSystems.length; i++) {
					this.optionSystemArray.push({ label: this.allSystems[i].systemName, value: this.allSystems[i]._id });
				}
			});
		},
		colorLabelText(value: any) {
		if (value == 1) {
			return ["text-lightgreen font-semibold"];
		} else if (value == 2) {
			return ["text-green font-semibold"];
		} else if (value == 3) {
			return ["text-yellow font-semibold"];
		} else if (value == 4) {
			return ["text-error font-semibold"];
		} else if (value == 5) {
			return ["text-darkred font-semibold"];
		}
		},
		colorLabelBg(value: any) {
			if (value == 1) {
				return ["bg-veryLowColor border-solid border border-lightgreen"];
			} else if (value == 2) {
				return ["bg-lowColor border-solid border border-green"];
			} else if (value == 3) {
				return ["bg-moderateColor border-solid border border-yellow"];
			} else if (value == 4) {
				return ["bg-highColor border-solid border border-error"];
			} else if (value == 5) {
				return ["bg-veryHighColor border-solid border border-darkred"];
			}
		},
		getProirityLabel(val:any){
			if (val === 'N/A') { 
				return ''; 
			} else {
				let a = this.dbPriority.find((obj: any) => obj.value == val);
				return (val && typeof val === 'number') ? a.key : '';
			}
		},
		controlKey(value: any) {
			if (value == null || value === '') {
				return '';
			}
			if (typeof value === 'string' || typeof value === 'number') {
				return String(value);
			}
			if (typeof value === 'object') {
				if (value.$oid) {
					return String(value.$oid);
				}
				if (value.oid) {
					return String(value.oid);
				}
				if (value._id) {
					return this.controlKey(value._id);
				}
			}
			return String(value);
		},
		frameworkRowName(frameworkRow: any) {
			return String(frameworkRow?.name || frameworkRow?.framework || frameworkRow?.frameWork || '').trim().toLowerCase();
		},
		controlsForFramework(frameworkName: any) {
			const selectedName = String(frameworkName || '').trim().toLowerCase();
			if (!selectedName) {
				return [];
			}
			if (selectedName === 'internal controls') {
				const controlNumber = this.presentTaskObject?.controlNumber;
				if (!controlNumber) {
					return [];
				}
				return [{
					controlNumber,
					controlTitle: this.presentTaskObject?.controlTitle || ''
				}];
			}
			const rows = Array.isArray(this.taskFrameworkControls) ? this.taskFrameworkControls : [];
			const entry = rows.find((frameworkRow: any) => this.frameworkRowName(frameworkRow) === selectedName);
			if (!entry || !Array.isArray(entry.controls)) {
				return [];
			}
			const mappedIds = new Set(entry.controls.map((id: any) => this.controlKey(id)).filter(Boolean));
			const catalog = Array.isArray(this.allFrameWorkControls) ? this.allFrameWorkControls : [];
			const options: any[] = [];
			const seen = new Set();
			catalog.forEach((control: any) => {
				const controlNumber = control?.controlNumber;
				if (!controlNumber || seen.has(controlNumber)) {
					return;
				}
				if (!mappedIds.has(this.controlKey(control?._id || control?.id))) {
					return;
				}
				seen.add(controlNumber);
				options.push({
					controlNumber,
					controlTitle: control.controlTitle || ''
				});
			});
			return options;
		},
		controlsForSelectedFramework() {
			return this.controlsForFramework(this.findingsObject.frameworks);
		},
		async refreshFindingFrameworks() {
			if (!Array.isArray(this.allFrameWorkControls) || this.allFrameWorkControls.length === 0) {
				await this.getAllControls();
			}
			const frameworkNames: string[] = [];
			const seenFrameworks = new Set<string>();
			const auditFrameworks = Array.isArray(this.presentAuditObject?.frameworks)
				? this.presentAuditObject.frameworks
				: [];
			auditFrameworks.forEach((name: any) => {
				const label = String(name || '').trim();
				const key = label.toLowerCase();
				if (!label || seenFrameworks.has(key)) {
					return;
				}
				if (this.controlsForFramework(label).length === 0) {
					return;
				}
				seenFrameworks.add(key);
				frameworkNames.push(label);
			});
			this.auditFrameworkArray = frameworkNames;
		},
		bindSelectedControlTitle(event?: any) {
			const controlNumber = event?.value ?? this.findingsObject.frameWorkControl;
			const selected = this.selectedFrameworkControls.find((control: any) => control.controlNumber === controlNumber);
			this.findingsObject.frameworkControlTitle = selected?.controlTitle || '';
		},
		async changeFrameWorkControlNums(preserveControl = false){
            const currentControl = this.findingsObject.frameWorkControl;
            const currentTitle = this.findingsObject.frameworkControlTitle || '';
            this.selectedFrameworkControls = []
            if (!preserveControl) {
                this.findingsObject.frameWorkControl = ''
                this.findingsObject.frameworkControlTitle = ''
            }
            if (!this.findingsObject.frameworks) {
                return;
            }
            if (!Array.isArray(this.allFrameWorkControls) || this.allFrameWorkControls.length === 0) {
                await this.getAllControls();
            }
            this.selectedFrameworkControls = this.controlsForSelectedFramework();
            if (preserveControl) {
                this.findingsObject.frameWorkControl = currentControl;
                const selected = this.selectedFrameworkControls.find((control: any) => control.controlNumber === currentControl);
                this.findingsObject.frameworkControlTitle = selected?.controlTitle || currentTitle;
            } else if (this.selectedFrameworkControls.length === 1) {
                this.findingsObject.frameWorkControl = this.selectedFrameworkControls[0].controlNumber;
                this.findingsObject.frameworkControlTitle = this.selectedFrameworkControls[0].controlTitle || '';
            }
        },
		async getplannerTasksForAudit(){
			this.tableRow=[];
			const taskId = this.currentTaskId;
			let payload={
				taskId:taskId
			}			
			await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/relatedTasks/get`, [payload]).then(async (result: any) => {
				let plannerTasks = result.data;
				if(plannerTasks.length>0){
					plannerTasks.forEach((subTask:any) => {
					let date:any;
					if(subTask.dueDate){
						date = moment(subTask.dueDate).format('YYYY-MM-DD')
					}
					let subTaskObj:any = {
						ccid: subTask?.clientUniqueId != undefined ? subTask.clientUniqueId : 'N/A',
						Title:subTask.TaskName && subTask.TaskName!=undefined?subTask.TaskName:'N/A',
						TaskId:subTask.taskId && subTask.taskId!=undefined?subTask.taskId:'N/A',
						statusCode:subTask.statusCode && subTask.statusCode!=undefined?subTask.statusCode:'N/A',
						Frequency:subTask.controlFrequency && subTask.controlFrequency!=undefined?subTask.controlFrequency:'N/A',
						dueDate:subTask.dueDate && subTask.dueDate!=undefined?date:'N/A',
					}
					console.log('sss',subTaskObj);
					
					this.tableRow.push(subTaskObj)
				});
				}
				
			})
		},
		getTierDetails(data: any) {
			let tier:any;
			let tierInfo:any;
			if (data.categoryType == 10107) {
			tier = 'Activity';
			const activity = this.optionsActivityArray.find(
			  (activity: any) => data.activityId?.toString() == activity.value?.toString()
			);
			tierInfo = activity ? activity.label : 'N/A';
			} else if (data.categoryType == 10108) {
			tier = 'System';
			const system = this.optionSystemArray.find(
			  (sys: any) => data.systemId?.toString() == sys.value?.toString()
			);
			tierInfo = system ? system.label : 'N/A';
			}
			else{
			tier = 'N/A';
			}
			return { tier,tierInfo };
		},
		async getTaskHistoryObject() {
			let auditId = this.currentAuditId;
			await this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/org/task/${this.currentTaskId}/getHistory`).then((result: any) => {
				const mainObject = result.data;
				this.workLogObject = mainObject;
				// console.log('workhossss', this.workLogObject);
			});
				this.workLogObject?.taskHistory?.sort().reverse();
		},
		async getAllAudits() {
			await this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/org/audits/getAll`).then((result: any) => {
				result.data.forEach((info: any) => {
					this.allAudits.push(info);
				});
				// console.log('allAudits', this.allAudits);
			});
		},
		getCategory(num: any) {
			let result = this.findingCategoryData.find((obj: any) => {
				return obj.id == num;
			});
			return result.value;
		},
		evidenceDisplayName(value: any) {
			const text = String(value ?? '');
			const file = (this.presentTaskObject?.files || []).find((doc: any) => String(doc?.url || '') === text || doc?.filename === text || doc?.name === text);
			return file?.filename || file?.name || text;
		},
		getLocationName(teamId: any) {
			let teamObj = this.users.find((obj: any) => {
                return obj._id == teamId;
            });
            if (teamObj == undefined) {
                return 'N/A';
            } else if(teamObj.entityType != undefined && teamObj.entityType == 20301) {
                return this.locationObject.find((l:any)=>l.entityType==1)?.label
            }else if(teamObj.entityType != undefined && teamObj.entityType == 20303){
				return teamObj.entityDisplayName
			}else{
				return 'N/A';
			}
        },
		onCancelIcon(){
			this.resetEvidenceForm();
			this.importpopUp = false;
		},
		resetEvidenceForm(){
			this.clickOnButton = false;
			this.inputFileName = '';
			this.fileName = '';
			this.evidenceDate = '';
			this.evidenceUrl = '';
			this.evidenceAttachMode = 'file';
			this.fileToUpload = null;
			this.pdfValidation = false;
			this.isDragOver = false;
			if (this.$refs.fileInput) {
				this.$refs.fileInput.value = '';
			}
			this.v$.$reset();
		},
		getStatusLabel(num:any){
			let result = this.taskStatusData.find((obj:any)=>{return obj.id == num})
			return result.status
		},
		async getAuditTaskStatuses(){
			let appId='10006';
			let entityId='10118';
			await this.$http.get(`${process.env.VUE_APP_AUTH_API}/${appId}/${entityId}/statuses`).then((result: any) => {
				
				this.taskStatusData = (result.data.statuses || [])
					.filter((item: any) => item.id != 10418)
					.map((item: any) => ({
						id: item.id,
						status: item.label
					}));
			});
		},
		updateAuditResult() {
			const category = this.findingsObject.findingCategory;
			if (category === 1 || category === 2) {
				this.findingsObject.auditResult = 'Fail';
			} else if (category === 3 || category === 4) {
				this.findingsObject.auditResult = 'Pass';
			} else {
				this.findingsObject.auditResult = '';
			}
		},
		// scrollTabIntoView(tabId : any) {
		// 	this.$nextTick(() => {
		// 		const tabElement = this.$el.querySelector(`.tab:nth-child(${tabId})`);
		// 		if (tabElement) {
		// 		tabElement.scrollIntoView({ behavior: 'smooth', inline: 'center' });
		// 		}
		// 	});
		// },
		getTeamName(team: any) {
            let teamObj = this.users.find((obj: any) => {
                return obj._id == team;
            });
            if (teamObj == undefined) {
                return '';
            } else {
                return teamObj.displayName;
            }
        },
		getBorder(){
            return `numberBorder numberNavy`
        },
		async getAllActiveUsers() {
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/active/getall`).then((res: any) => {
				this.orgUsersList = res.data;
				for (var i = 0; i < this.orgUsersList.length; i++) {
					// if(this.orgUsersList[i].isActive == true){
					if(this.orgUsersList[i].roleId!=10217){
						this.assignedToList.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
					}
					this.optionsUserArray.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
					// }
				}
			});
		},
		async getallEntities() {
            this.locationObject = []
			let result:any
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
                result = res.data;
            });
            for (var i = 0; i < result.length; i++) {
                this.locationObject.push({ label: result[i].entityDisplayName, value: result[i]._id,entityType:result[i].entityType });
            }
        },
		async getAllTeams() {
            this.teamObject = []
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/departments/get`).then((res: any) => {
                this.users = res.data;
            });
            for (var i = 0; i < this.users.length; i++) {
                this.teamObject.push({ label: this.users[i].displayName, value: this.users[i]._id });
            }
        },
		getPersonName(person: any) {
			let personObj = this.orgUsersList.find((user: any) => {
				return user._id == person;
			});
			if (personObj == undefined && person==undefined) {
				return '';
			} else if(person!=undefined && personObj==undefined){								
				if(this.userInfo._id==person){					
					return this.userInfo.name;
				}
				else{
					return '';
				}
			}else {
				return personObj.name;
			}
		},
		getPerson(person: any) {
			this.personObj = this.orgUsersList.find((user: any) => {
              
				return user._id == person;
			});
			if (this.personObj == undefined) {
				return '';
			} else {
				return this.personObj.name;
			}
		},
		sortWorkLog() {
			this.newHistory = !this.newHistory;
			this.workLogObject?.taskHistory?.sort().reverse();
		},
		sortComments() {
			this.oldComments = !this.oldComments;
			if(this.presentTaskObject.comments != undefined){
				this.presentTaskObject.comments.sort().reverse();
			}
		},
		formatTime(time: any) {
			let now = moment(time);
			return now.format('DD-MM-YYYY, HH:mm:ss');
		},
		extractInitials(name: any) {
			if(name!=undefined) {
				const names = name.split(' ');
				return names
				.map((name: any) => name[0])
				.join('')
				.toUpperCase();
			}
			else {
				return '';
			}
		},
		changeBackground() {
			if (this.TaskDetailsDropDown.taskStatus == 10401) {
				return 'bg-disabledgrey textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10421) {
				return 'bg-yellow textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10414 || this.TaskDetailsDropDown.taskStatus == 10415) {
				return 'pendingEvidence-status textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10416) {
				return 'bg-primary textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10403) {
				return 'bg-lightgreen textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10417 || this.TaskDetailsDropDown.taskStatus == 10418) {
                return 'bg-darkred textColorWhite';
            }else {
				return '';
			}
		},
		checkAuditor(id:any){
			if(id == this.userInfo._id){
				return true
			} else if(id == undefined || id == null){
				return false
			} else {
				return false
			}
		},
		
		onAssigneeSelect(event:any) {
			this.updateAssignedMember(event.value); 
		},
		async updateTaskStatus(status: any) {
            if(this.presentTaskObject!=undefined && this.presentTaskObject.statusCode && this.presentTaskObject.statusCode==status){
                return;
            }
            if (status == 10403) {
                const previousStatus = this.presentTaskObject.statusCode;
                this.TaskDetailsDropDown.taskStatus = previousStatus;
                this.statusSelectKey += 1;
                await this.$nextTick();
                try {
                    await this.getAuditFindings(this.currentAuditId, this.currentTaskId);
                } catch (e) {
                    this.TaskDetailsDropDown.taskStatus = previousStatus;
                    return;
                }
                const realFindings = (this.findingsForTask || []).filter((finding: any) => finding && finding._id && finding.findingId && finding.findingId !== 'N/A');
                if (realFindings.length) {
                    this.TaskDetailsDropDown.taskStatus = previousStatus;
                    this.showCompleteFindingsDialog = true;
                    return;
                }
                this.TaskDetailsDropDown.taskStatus = 10403;
            }
            let payload: any = { statusCode: status };
            await this.updateAuditTask(4, payload);
        },
		cancelCompleteWithFindings() {
			this.showCompleteFindingsDialog = false;
			this.TaskDetailsDropDown.taskStatus = this.presentTaskObject.statusCode;
		},
		async confirmCompleteWithFindings() {
			this.showCompleteFindingsDialog = false;
			await this.updateAuditTask(4, { statusCode: 10403 });
		},
		async updateAssignedMember(obj: any) {
			let payload: any = { assignee: obj.value };
			await this.updateAuditTask(5, payload);
		},
		handleInput() {
			this.btnDisabled = this.comment.length === 0;
		},
		async addComment() {
			if (this.comment.trim() !== '') {
				const newComment: any = {
					comment: this.comment
				};
				await this.updateAuditTask(1, newComment);
				// this.comments.push(newComment);
				if(this.presentTaskObject.comments != undefined){
					this.presentTaskObject.comments.sort().reverse();
				}
				this.comment = '';
				this.btnDisabled = true;
			}
		},
		clearComment() {
			this.comment = '';
			this.btnDisabled = true;
		},
		async toggleTabs(obj: any) {
			this.tabDataLoading = true
			// this.scrollTabIntoView(obj.id);
			this.selectedTabIndex = obj.id;
			this.selectedTabObj = obj;
			// sessionStorage.setItem('selectedTab', obj.id);
			const auditId =this.currentAuditId
			const taskId=this.currentTaskId
			if(this.selectedTabIndex ==1 ){
				await this.getAllControls();
			}
			if(this.selectedTabIndex == 6) {
				await this.getAuditFindings(this.currentAuditId,this.currentTaskId)
			}
			await this.getTaskHistoryObject()
			await this.getPresentTaskObject(auditId,taskId);
			await this.getplannerTasksForAudit();
			this.tabDataLoading = false
		},
		blankFinding() {
			return {
				findingId: '',
				frameworks: '',
				frameWorkControl: '',
				frameworkControlTitle: '',
				findingCategory: '',
				findingSeverity: '',
				findingComment: '',
				findingEvidence: '',
				auditResult: ''
			};
		},
		async loadFindingSeverityLabelOptions() {
			const valuesOf = (result: any) => {
				const values = result?.data?.[0]?.values;
				return Array.isArray(values) ? values : [];
			};
			try {
				const risk = await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/label/20420/getall`);
				this.controlRiskSeverityLabelOptions = valuesOf(risk).filter((item: any) =>
					item && String(item.key).toUpperCase() !== 'N/A' && Number(item.value) !== 0
				);
			} catch (error) {
				this.controlRiskSeverityLabelOptions = [];
			}
		},
		getFindingSeverityValue(obj: any) {
			const raw = obj?.finding_severity ?? obj?.findingSeverity ?? obj;
			if (raw == null || raw === '') return null;
			if (typeof raw === 'object') {
				const nested = raw.value != null && raw.value !== '' ? Number(raw.value) : NaN;
				return Number.isFinite(nested) && nested > 0 ? nested : null;
			}
			const numeric = Number(raw);
			return Number.isFinite(numeric) && numeric > 0 ? numeric : null;
		},
		getFindingSeverityLabel(obj: any) {
			const raw = obj?.finding_severity ?? obj?.findingSeverity;
			if (raw == null || raw === '') return 'N/A';
			if (typeof raw === 'object' && raw.label != null && String(raw.label).trim() !== '') {
				return String(raw.label);
			}
			return this.getFindingSeverityHistoryLabel(this.getFindingSeverityValue(obj));
		},
		getFindingSeverityHistoryLabel(raw: any) {
			if (raw == null || raw === '') return 'N/A';
			if (typeof raw === 'string' && Number.isNaN(Number(raw))) {
				return raw;
			}
			const value = this.getFindingSeverityValue({ findingSeverity: raw });
			if (value == null) return 'N/A';
			const match = (this.controlRiskSeverityLabelOptions || []).find((item: any) => Number(item.value) === Number(value));
			return match?.key != null ? String(match.key) : 'N/A';
		},
		isDisabledFindingSeverityLabel(label: any) {
			const text = String(label || '').trim().toUpperCase();
			return text === 'N/A' || text === 'NONE';
		},
		findingSeverityChipBg(obj: any) {
			const label = this.getFindingSeverityLabel(obj);
			if (this.isDisabledFindingSeverityLabel(label)) {
				return ['bg-lightgrey border-solid border border-lightgrey'];
			}
			const value = this.getFindingSeverityValue(obj);
			return this.colorLabelBg(value) || ['bg-lightgrey border-solid border border-lightgrey'];
		},
		findingSeverityChipText(obj: any) {
			const label = this.getFindingSeverityLabel(obj);
			if (this.isDisabledFindingSeverityLabel(label)) {
				return ['text-gray text-xs font-semibold'];
			}
			const value = this.getFindingSeverityValue(obj);
			const textClass = this.colorLabelText(value);
			return textClass ? [...textClass, 'text-xs'] : ['text-gray text-xs font-semibold'];
		},
		async showFindingPopup() {
			if (!this.showPopUp) {
				await this.refreshFindingFrameworks();
				await this.loadFindingSeverityLabelOptions();
			}
			this.showPopUp = !this.showPopUp;
			const blank: any = this.blankFinding();
			if(this.showPopUp == true){
                let uuid = uuidv4();
                const truncatedUuid = uuid.replace(/-/g,'').substring(0, 8).toUpperCase();
                blank.findingId = truncatedUuid;
            }
			this.findingsObject = { ...blank };
			this.findingsObjectDummy = { ...blank };
			this.selectedFrameworkControls = [];
			this.v$.$reset();
		},
		async openExistingFinding(finding: any) {
			if (!this.canOpenFinding(finding)) {
				return;
			}
			const evidence = Array.isArray(finding.findingEvidence)
				? [...finding.findingEvidence]
				: (finding.findingEvidence ? [finding.findingEvidence] : []);
			const mappedEvidence = evidence.map((item: any) => {
				const text = String(item ?? '');
				const byValue = this.evidenceArray.find((opt: any) => opt.value === text);
				if (byValue) return byValue.value;
				const nameMatches = this.evidenceArray.filter((opt: any) => opt.filename === text);
				return nameMatches.length === 1 ? nameMatches[0].value : text;
			});
			await this.loadFindingSeverityLabelOptions();
			this.findingsObject = {
				_id: finding._id,
				findingId: finding.findingId,
				frameworks: finding.frameworks || '',
				frameWorkControl: finding.frameWorkControl || '',
				frameworkControlTitle: finding.frameworkControlTitle || finding.controlTitle || '',
				findingCategory: finding.findingCategory,
				findingSeverity: this.getFindingSeverityValue(finding) ?? '',
				findingComment: finding.findingComment || '',
				findingEvidence: mappedEvidence,
				auditResult: finding.auditResult || '',
				systemId: finding.systemId,
				activityId: finding.activityId,
				categoryType: finding.categoryType
			};
			await this.changeFrameWorkControlNums(true);
			this.findingsObjectDummy = JSON.parse(JSON.stringify(this.findingsObject));
			this.v$.$reset();
			this.showPopUp = true;
		},
		onCancelButtonAddPopUp() {
			this.showPopUp = false;
			this.onCancelbtn();
		},
		openFilePopup(mode: string = 'file') {
			this.resetEvidenceForm();
			this.evidenceAttachMode = mode === 'url' ? 'url' : 'file';
			this.importpopUp = true;
		},
		async handleUrlEvidenceSave() {
			this.v$.inputFileName.$touch();
			this.v$.evidenceUrl.$touch();
			this.v$.evidenceDate.$touch();
			if (this.v$.inputFileName.$invalid || this.v$.evidenceUrl.$invalid || this.v$.evidenceDate.$invalid) {
				return;
			}
			this.clickOnButton = true;
			this.importpopUp = false;
			try {
				const payload: any = {
					url: this.evidenceUrl,
					filename: this.inputFileName,
					evidenceDate: new Date(this.evidenceDate).toISOString(),
					evidenceType: 'url'
				};
				await this.updateAuditTask(3, payload);
				this.resetEvidenceForm();
			} catch (err) {
				console.error(err);
				toast.error(`Error`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
				this.resetEvidenceForm();
			} finally {
				this.clickOnButton = false;
			}
		},
		updateFileName(event: any) {
			// const selectedFile = event.target.files[0];
			// this.newDocumentObj.file = selectedFile;
			let file = this.$refs.fileInput.files[0];

			if (file && !file.type.match('application/pdf') && !file.name.endsWith('.doc') && !file.name.endsWith('.docx')) {
				alert('Please select a PDF, DOC, or DOCX file.');
				return;
			} else {
				this.fileChanged = true;
				this.fileToUpload.file = file;
			}
		},
		onDragOver() {
			this.isDragOver = true;
		},
		onDragLeave() {
			this.isDragOver = false;
		},

		onFileDrop(event:any) {
			this.isDragOver = false;
			const file = event.dataTransfer?.files?.[0];
			if (file) {
			this.applySelectedFile(file);
			}
		},
		handleFileUpload(event:any) {
			const file = event?.target?.files?.[0];
			if (file) {
			this.applySelectedFile(file);
			} else {
			this.fileName = '';
			this.inputFileName = '';
			}
		},
		applySelectedFile(file:any) {
			this.fileName = file.name;
			this.fileToUpload = file;

			const fileNameParts = file.name.split('.');
			fileNameParts.pop();
			const nameWithoutExtension = fileNameParts.join('.');
			if (this.inputFileName.trim() === '') {
			this.inputFileName = nameWithoutExtension;
			}
			// const fileExtension = file.name.split('.').pop();
			const fileExtension = file.name.split('.').pop()?.toLowerCase();
			if (
			fileExtension == 'pdf' || fileExtension == 'docx' || fileExtension == 'xls' ||
			fileExtension == 'xlsx' || fileExtension == 'jpeg' || fileExtension == 'png' ||
			fileExtension == 'jpg' || fileExtension == 'mp4' || fileExtension == 'doc' ||
			fileExtension == 'rtf' || fileExtension == 'txt' || fileExtension == 'csv' ||
			fileExtension == 'zip' || fileExtension == 'ods'
			) {
			this.pdfValidation = false;
			this.v$.$reset();
			} else {
			this.pdfValidation = true;
			}
		},
		clearSelectedFile() {
			this.fileName = '';
			this.fileToUpload = '';
			this.pdfValidation = false;
			this.v$.$reset();

			if (this.$refs.fileInput) {
				this.$refs.fileInput.value = '';
			}
		},
		// handleFileUpload(event: any) {
        //     const file = this.$refs.fileInput.files[0];
        //     if (file) {
        //         this.fileName = file.name;
        //         this.fileToUpload = file
        //          const fileNameParts = file.name.split('.');
        //         // console.log('fileNameParts1',fileNameParts)
        //         fileNameParts.pop(); // Remove the extension
        //         // console.log('fileNameParts2',fileNameParts)
        //         const nameWithoutExtension = fileNameParts.join('.');
        //         // console.log('fileNameParts',nameWithoutExtension)
        //         if (this.inputFileName.trim() === '') {
        //         this.inputFileName = nameWithoutExtension;
        //         }
        //         // console.log('inputFileName',this.inputFileName)
        //     } else {
        //         this.fileName = '';
        //         this.inputFileName = '';
        //     }
        // },
		async handleFileChange(event: any) {
			if (this.evidenceAttachMode === 'url') {
				await this.handleUrlEvidenceSave();
				return;
			}
			this.clickOnButton = true;
			// let data = this.$refs.fileInput.files[0];
			let data = this.fileToUpload;
			this.v$.inputFileName.$touch()
			this.v$.fileToUpload.$touch()
			this.v$.evidenceDate.$touch()
			if(((!this.v$.fileToUpload.$invalid) && (!this.v$.inputFileName.$invalid)  && (!this.v$.evidenceDate.$invalid) && !this.pdfValidation)){
			this.importpopUp = !this.importpopUp
			let fileExtension = data.name.split('.').pop();
			if (fileExtension == 'pdf' || fileExtension == 'docx' || fileExtension == 'xls' || fileExtension == 'xlsx' || fileExtension == 'jpeg'|| fileExtension == 'png'|| fileExtension == 'jpg' || fileExtension == 'mp4'|| fileExtension == 'doc' || fileExtension == 'rtf' || fileExtension == 'txt' || fileExtension == 'csv' || fileExtension=='zip' || fileExtension == 'ods') {
				const fileDataFormat = await this.getConvertDataForFile(data);
				let uuid = uuidv4();
				let payload = { fileData: fileDataFormat,fileType:1, name: `${uuid}.${fileExtension}` };
				// let folderName = 'audit';
				let folderName = process.env.VUE_APP_AUDIT_FOLDER_NAME;
				try {
					await this.$http
						.post(`${process.env.VUE_APP_FILE_API}/bucket/${folderName}/file/upload`, payload)
						// .post(`http://localhost:4030/services/filemanagement/bucket/${folderName}/file/upload`, payload)
						// bucket/:folderName/file/upload
						.then(async (response: any) => {
							if (response.status == 200) {
								let payload: any = {
									name: `${uuid}.${fileExtension}`,
									url: response.data,
									filename:this.inputFileName,
									evidenceDate: new Date(this.evidenceDate).toISOString(),
									fileType:1,
									evidenceType: 'file'
								};
								await this.updateAuditTask(3, payload);
								this.resetEvidenceForm();
							} else {
								// console.log('response status', response.status);
							}
						});
				} catch (err) {
					// console.error(err);
				} finally {
					this.clickOnButton = false;
				}
			} else {
				toast.error(`Upload only pdf`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
			this.fileName = '';
            this.inputFileName = '';
			this.fileToUpload=null
			
			}
			this.clickOnButton = false;
		},
		isOptionDisabled(option:any) {	
					
			return this.disabledStatuses.includes(option.id);
		},
		isEvidenceAttachDisabled() {
			return this.TaskDetailsDropDown.taskStatus == 10401 || this.TaskDetailsDropDown.taskStatus == 10403 || this.TaskDetailsDropDown.taskStatus == 10417 || this.TaskDetailsDropDown.taskStatus == 10418 || !this.isAddDisabled(10302);
		},
		isPlannerCreatedEvidence(doc: any) {
			const plannerFolder = String(process.env.VUE_APP_PLANNER_FOLDER_NAME || '').trim();
			if (plannerFolder && String(doc?.url || '').includes(`/${plannerFolder}/`)) return true;
			const currentTaskId = String(this.presentTaskObject?.taskId ?? '');
			return doc?.taskId != null && String(doc.taskId) !== '' && String(doc.taskId) !== currentTaskId;
		},
		isPlannerLinkedEvidence(doc: any) {
			if (!doc) return false;
			const url = String(doc?.url || '');
			const plannerFolder = String(process.env.VUE_APP_PLANNER_FOLDER_NAME || '').trim();
			const monitorFolder = String(process.env.VUE_APP_MONITOR_FOLDER_NAME || '').trim();
			const auditFolder = String(process.env.VUE_APP_AUDIT_FOLDER_NAME || '').trim();
			const inFolder = (folder: string) => !!folder && url.includes(`/${folder}/`);
			if (inFolder(plannerFolder)) return true;
			if (inFolder(monitorFolder) || inFolder(auditFolder)) return false;
			const currentTaskId = String(this.presentTaskObject?.taskId ?? '');
			const fileTaskId = doc?.taskId != null ? String(doc.taskId) : '';
			return fileTaskId !== '' && fileTaskId !== currentTaskId;
		},
		canDeleteAuditEvidence(doc: any) {
			if (!doc) return false;
			const currentTaskId = String(this.presentTaskObject?.taskId ?? '');
			const fileTaskId = doc?.taskId != null ? String(doc.taskId) : '';
			if (doc.linkedEvidenceTaskId != null && String(doc.linkedEvidenceTaskId) !== '' && fileTaskId === currentTaskId) return true;
			if (this.isPlannerLinkedEvidence(doc)) return false;
			const url = String(doc?.url || '');
			const plannerFolder = String(process.env.VUE_APP_PLANNER_FOLDER_NAME || '').trim();
			const monitorFolder = String(process.env.VUE_APP_MONITOR_FOLDER_NAME || '').trim();
			if (plannerFolder && url.includes(`/${plannerFolder}/`)) return false;
			if (monitorFolder && url.includes(`/${monitorFolder}/`)) return false;
			const auditFolder = String(process.env.VUE_APP_AUDIT_FOLDER_NAME || '').trim();
			if (auditFolder && url.includes(`/${auditFolder}/`)) return true;
			const sourceTaskId = doc?.linkedEvidenceTaskId
				? String(doc.linkedEvidenceTaskId)
				: (fileTaskId && fileTaskId !== currentTaskId ? fileTaskId : '');
			if (!sourceTaskId) return true;
			const prefix = (id: string) => (id.match(/^[A-Za-z]+/) || [''])[0].toUpperCase();
			return prefix(sourceTaskId) === prefix(currentTaskId);
		},
		evidenceTaskLabel(doc: any) {
			return doc?.taskId || 'N/A';
		},
		openDeleteEvidenceConfirm(evidenceIndex: number) {
			if (evidenceIndex < 0) return;
			this.deleteEvidenceIndex = evidenceIndex;
			this.showDeleteEvidenceConfirm = true;
		},
		cancelDeleteEvidence() {
			this.showDeleteEvidenceConfirm = false;
			this.deleteEvidenceIndex = null;
		},
		async confirmDeleteEvidence() {
			const evidenceIndex = this.deleteEvidenceIndex;
			this.showDeleteEvidenceConfirm = false;
			this.deleteEvidenceIndex = null;
			if (evidenceIndex == null) return;
			await this.removeEvidence(evidenceIndex);
		},
		async removeEvidence(evidenceIndex: number) {
			if (this.isEvidenceAttachDisabled()) return;
			const evidence = this.presentTaskObject?.files?.[evidenceIndex];
			if (!this.canDeleteAuditEvidence(evidence)) return;
			const url = evidence?.url;
			const isUrlEvidence = evidence?.evidenceType === 'url';
			const plannerFolder = String(process.env.VUE_APP_PLANNER_FOLDER_NAME || '').trim();
			const monitorFolder = String(process.env.VUE_APP_MONITOR_FOLDER_NAME || '').trim();
			const isPlannerOrMonitorFile = [plannerFolder, monitorFolder].some((folder) => folder && String(url || '').includes(`/${folder}/`));
			try {
				let urlStillUsed = false;
				if (!isUrlEvidence && url && !isPlannerOrMonitorFile) {
					const tasksResponse = await this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/tasks/getall`);
					const tasks = Array.isArray(tasksResponse?.data) ? tasksResponse.data : [];
					const currentId = String(this.currentTaskId || '');
					urlStillUsed = tasks.some((task: any) => String(task?._id || '') !== currentId && Array.isArray(task?.files) && task.files.some((doc: any) => doc?.url === url));
				}
				if (!isUrlEvidence && url && !urlStillUsed && !isPlannerOrMonitorFile) {
					const fileResponse = await this.$http.post(`${process.env.VUE_APP_FILE_API}/bucket/file/delete`, { url });
					if (!(fileResponse.status == 200 && fileResponse.data?.deleted === true)) {
						return;
					}
				}
				await this.$http.post(
					`${process.env.VUE_APP_AUDIT_API}/task/${this.currentTaskId}/evidence/remove`,
					{ evidenceIndex, createdBy: this.userInfo._id }
				);
				await this.getPresentTaskObject(this.currentAuditId, this.currentTaskId);
				await this.getTaskHistoryObject();
			} catch (err) {
				toast.error(`Failed to remove evidence`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
		},
		async loadExistingFileOptions() {
			try {
				const [auditTaskRes, auditCapaRes, monitorTaskRes, monitorCapaRes, plannerRes] = await Promise.all([
					this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/tasks/getall`),
					this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/capa-tasks/getall`),
					this.$http.get(`${process.env.VUE_APP_MONITOR_API}/api/org/tasks/getall`),
					this.$http.get(`${process.env.VUE_APP_MONITOR_API}/capa/tasks`),
					this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/tasks/getAll`),
				]);
				const auditTasks = Array.isArray(auditTaskRes?.data) ? auditTaskRes.data : [];
				const auditCapaTasks = Array.isArray(auditCapaRes?.data) ? auditCapaRes.data : [];
				const monitorCrTasks = (Array.isArray(monitorTaskRes?.data) ? monitorTaskRes.data : []).filter((task: any) => task?.actionType == 20501);
				const monitorCapaTasks = Array.isArray(monitorCapaRes?.data) ? monitorCapaRes.data : [];
				const plannerTasks = (Array.isArray(plannerRes?.data) ? plannerRes.data : []).map((task: any) => ({
					...task,
					files: Array.isArray(task.evidences) ? task.evidences : task.files
				}));
				this.linkEvidenceTasks = auditTasks.concat(auditCapaTasks, monitorCrTasks, monitorCapaTasks, plannerTasks);
			} catch (error) {
				this.linkEvidenceTasks = [];
				toast.error(`Failed to load tasks`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
		},
		resetExistingEvidenceTable() {
			this.existingEvidenceSortKey = '';
			this.existingEvidenceSortDir = 'asc';
			this.showExistingEvidenceFilters = false;
			this.existingEvidenceFilters = { filename: '', sourceTaskId: '', evidenceType: '', evidenceDate: '' };
		},
		toggleExistingEvidenceFilters() {
			this.showExistingEvidenceFilters = !this.showExistingEvidenceFilters;
			if (!this.showExistingEvidenceFilters) {
				this.existingEvidenceFilters = { filename: '', sourceTaskId: '', evidenceType: '', evidenceDate: '' };
			}
		},
		existingEvidenceTypeLabel(row: any) {
			if (row?.evidenceType === 'url') return String(row.evidenceType).toUpperCase();
			const values = [row?.name, row?.url, row?.filename];
			for (const value of values) {
				const text = String(value || '').split('?')[0];
				const ext = (text.split('.').pop() || '').toLowerCase();
				if (ext && ext !== text.toLowerCase()) return ext.toUpperCase();
			}
			return String(row?.evidenceType || 'file').toUpperCase();
		},
		sortExistingEvidence(key: string) {
			if (this.existingEvidenceSortKey === key) {
				this.existingEvidenceSortDir = this.existingEvidenceSortDir === 'asc' ? 'desc' : 'asc';
			} else {
				this.existingEvidenceSortKey = key;
				this.existingEvidenceSortDir = 'asc';
			}
		},
		openLinkEvidencePopup() {
			this.selectedExistingEvidences = [];
			this.resetExistingEvidenceTable();
			this.linkEvidencePopup = true;
			this.loadExistingFileOptions();
		},
		closeLinkEvidencePopup() {
			this.linkEvidencePopup = false;
			this.selectedExistingEvidences = [];
			this.resetExistingEvidenceTable();
		},
		isExistingEvidenceSelected(row: any) {
			return (this.selectedExistingEvidences || []).some((item: any) => item.optionKey === row.optionKey);
		},
		toggleExistingEvidence(row: any) {
			const selected = [...(this.selectedExistingEvidences || [])];
			const index = selected.findIndex((item: any) => item.optionKey === row.optionKey);
			if (index >= 0) {
				selected.splice(index, 1);
			} else {
				selected.push(row);
			}
			this.selectedExistingEvidences = selected;
		},
		async saveLinkedEvidence() {
			const docs = this.selectedExistingEvidences || [];
			const files = docs.filter((doc: any) => doc?.url).map((doc: any) => {
				const filename = doc.filename || doc.name;
				const item: any = {
					url: doc.url,
					filename,
					evidenceDate: doc.evidenceDate,
					evidenceType: doc.evidenceType || 'file'
				};
				if (doc.name) {
					item.name = doc.name;
				}
				if (doc.fileType !== undefined && doc.fileType !== null) {
					item.fileType = doc.fileType;
				}
				if (doc.sourceTaskId != null && String(doc.sourceTaskId) !== '') {
					item.linkedEvidenceTaskId = String(doc.sourceTaskId);
				}
				return item;
			});
			if (!files.length) return;
			this.linkEvidencePopup = false;
			this.selectedExistingEvidences = [];
			await this.updateAuditTask(3, { files });
		},
		async updateAuditTask(type: any, payload: any) {
			payload.createdBy = this.userInfo._id;
            payload.createdAt = moment().format('YYYY-MM-DD HH:mm:ss');
			if(type == 1){
				payload.additionalInfo = {comment:''};
				payload.additionalInfo.comment = payload.comment;
			}else if(type == 2){
                payload.additionalInfo = { findingId: payload.findingId };
                delete payload._id;
            }else if(type == 10){
				payload.additionalInfo = { deletedFindingId: payload.findingId };
			}else if(type == 3){
				if (Array.isArray(payload.files)) {
					payload.files.forEach((item: any) => {
						item.createdBy = payload.createdBy;
						item.taskId = this.presentTaskObject?.taskId;
						item.additionalInfo = { evidence: item.filename, evidenceDate: item.evidenceDate };
					});
				} else {
				payload.taskId = this.presentTaskObject?.taskId
				payload.additionalInfo = {evidence:'',evidenceDate:''};
				payload.additionalInfo.evidence = payload.filename;
				payload.additionalInfo.evidenceDate=payload.evidenceDate;
				payload.fileType=payload.fileType
				}
			}else if(type == 4){
				payload.additionalInfo = {previousStatus:'',updatedStatus:''};
				payload.additionalInfo.previousStatus = this.presentTaskObject.statusCode;
				payload.additionalInfo.updatedStatus = payload.statusCode;
				 if (payload.statusCode==10401 && this.TaskDetailsDropDown.taskStatus==10401) this.disabledStatuses = [];
					else if (payload.statusCode==10421) this.disabledStatuses = [10401];
					else if (payload.statusCode==10414) this.disabledStatuses = [10401, 10421];
					else if (payload.statusCode==10415) this.disabledStatuses = [10401];
					else if(payload.statusCode == 10416 ) this.disabledStatuses = [10401];
					else if(payload.statusCode == 10403) this.disabledStatuses = [10401,10421,10414,10416];
					else if(payload.statusCode == 10417) this.disabledStatuses = [10401,10421,10414,10416,10403]
					else this.disabledStatuses = [];
			}else if(type == 5){
				payload.additionalInfo = {assignee:''};
				payload.additionalInfo.assignee = payload.assignee;
			}else if(type == 8){
				let dueDateUpdate:any={
					previousDueDate:this.dummyPresentTaskObject.dueDate?this.dummyPresentTaskObject.dueDate:'',
					updatedDueDate:new Date(payload.dueDate)
				}
				payload.additionalInfo = dueDateUpdate

				console.log('updated date',type,payload);
				

			}
			try {
				await this.$http.post(`${process.env.VUE_APP_AUDIT_API}/task/${this.currentTaskId}/type/${type}/update`, payload).then(async (result: any) => {
					toast.info(`Updated`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
					await this.getPresentAuditObject();
					await this.getPresentTaskObject(this.currentAuditId,this.currentTaskId);
					await this.getTaskHistoryObject();
					await this.getAuditFindings(this.currentAuditId,this.currentTaskId)
				});
			} catch (e:any){
				if(e.response.status==403){
						toast.error(`${e.response.data.error}`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});	
				}
				else {
					toast.error(`Error`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
				}
			} finally {
				this.clickOnButtonForFinding = false;
			}
		},
		async getConvertDataForFile(data: any) {
			return new Promise((resolve) => {
				const reader: any = new FileReader();
				reader.onload = function () {
					// resolve(reader.result.replace('data:', '').replace(/^.+,/, ''));
					 resolve(reader.result);
				};
				reader.readAsDataURL(data);
			});
		},
		 colorAuditText(status: any) {
			if (status == 10401) {
				return ['font-semibold text-xs text-disabledgrey'];
			} else if (status == 10402|| status==10421) {
				return ['font-semibold text-xs text-yellow'];
			} else if (status == 10403) {
				return ['font-semibold text-xs text-lightgreen'];
			} else if(status == 10414|| status == 10415){
				return ['font-semibold text-xs text-electricGreen']
			} else if(status == 10416){
				return ['font-semibold text-xs mx-2 text-primary']
			}else if(status == 10417 || status == 10418){
				return ['font-semibold text-xs mx-2 text-darkred']
			}
		},
		colorAuditBg(status: any) {
			if (status == 10401) {
				return ['bg-lightgrey border-solid border border-disabledgrey'];
			} else if (status == 10402 || status==10421) {
				return ['bg-moderateColor border-solid border border-yellow'];
			} else if (status == 10403) {
				return ['bg-veryLowColor border-solid border border-lightgreen'];
			} else if (status == 10414|| status == 10415) {
				return ['pendingEvidence border-solid border border-electricGreen'];
			} else if (status == 10416) {
				return ['evidenceUpload border-solid border border-primary'];
			}else if (status == 10417 || status == 10418) {
				return ['bg-veryHighColor border-solid border border-darkred'];
			}
		},
		onCancelbtn() {
			this.v$.$reset();
			if (this.findingsObject._id) {
				this.findingsObject = JSON.parse(JSON.stringify(this.findingsObjectDummy));
				this.changeFrameWorkControlNums(true);
				return;
			}

			(this.findingsObject.frameworks = ''),(this.findingsObject.frameWorkControl = ''), (this.findingsObject.frameworkControlTitle = ''), (this.findingsObject.findingCategory = ''), (this.findingsObject.findingSeverity = ''), (this.findingsObject.findingComment = ''), (this.findingsObject.findingEvidence = ''),(this.findingsObject.auditResult = '');
		},
		getControlDetails(controlNumber : any) {
			const control = this.allFrameWorkControls.find((item:any) => item.controlNumber === controlNumber);
			return control ? { controlNumber: control.controlNumber, description: control.controlAuditMethodology} : null;
		},
		async getAllControls(){
            await this.$http
				.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/allControls`)
				.then((result: { data: any }) => {
                    let controls:any = result.data;
                    this.allFrameWorkControls = result.data;
				})
				.catch((error: any) => {
                    toast.error(` ${error}`, {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                    });
				});
        },
		async saveEnteredFinding() {
            this.v$.$touch();
            if (!this.v$.findingsObject.$invalid) {
                 this.clickOnButtonForFinding = true;
                 let currentTask = this.currentTaskId;
                 let matchedTask = this.tasksForAudit.find((task:any)=>task._id==currentTask);
                if(matchedTask!=undefined){
                    if(matchedTask.systemId){
                        this.findingsObject.systemId = matchedTask.systemId;
                        this.findingsObject.categoryType = matchedTask.categoryType;                        
                    }else if(matchedTask.activityId){
                        this.findingsObject.activityId =matchedTask.activityId;
                        this.findingsObject.categoryType =matchedTask.categoryType;
                    }
                }
                const findingPayload = { ...this.findingsObject };
                delete findingPayload._id;
                delete findingPayload.finding_severity;
                findingPayload.findingSeverity = this.getFindingSeverityValue(findingPayload.findingSeverity);
                const selectedEvidence = Array.isArray(findingPayload.findingEvidence) ? findingPayload.findingEvidence : [];
                const optionValues = new Set((this.evidenceArray || []).map((opt: any) => opt.value));
                const selectedOptions = selectedEvidence.filter((value: any) => optionValues.has(value));
                if (selectedOptions.length) {
                    findingPayload.findingEvidence = selectedOptions;
                }
                await this.updateAuditTask(2, findingPayload);
                this.showPopUp = !this.showPopUp;
                this.onCancelbtn();
            }
        },
		async getPresentAuditObject() {
			await this.$http
				.get(`${process.env.VUE_APP_AUDIT_API}/api/org/audit/${this.currentAuditId}/get`)
				.then((result: { data: any }) => {
					this.presentAuditObject = result.data;
					let teamLeaderObj:any = this.optionsUserArray.find((obj:any)=>{return obj.value == this.presentAuditObject.teamOwner});
					this.presentAuditObject.teamLeader = teamLeaderObj;

					if(teamLeaderObj != undefined){
						this.TeamLeaderValue = teamLeaderObj.value
					}
					// this.auditFrameworkArray = this.presentAuditObject.frameworks;
					
					
        			
				})
				.catch((error: any) => {
					toast.error(` ${error}`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
				});
		},
		async getPresentTaskObject(aId:any,tId:any) {
			this.tasksForAudit = [];
			this.auditFrameworkArray = []

			await this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/org/audit/${aId}/tasks/get`).then(async (result: any) => {
				this.tasksForAudit = result.data;

				let present = result.data.find((obj: any) => {
					return obj._id == tId;
				});
				this.presentTaskObject = { ...present };
				this.dummyPresentTaskObject={...present};
				this.taskFrameworkControls = Array.isArray(present?.frameworks)
					? present.frameworks.map((row: any) => ({
						name: row?.name,
						framework: row?.framework,
						frameWork: row?.frameWork,
						controls: Array.isArray(row?.controls) ? [...row.controls] : []
					}))
					: [];

				// console.log('this.presentTaskObjectthis.presentTaskObject',this.presentTaskObject)

				await this.refreshFindingFrameworks();

				this.TaskDetailsDropDown.taskStatus = this.presentTaskObject.statusCode;

					let userObj:any = this.optionsUserArray.find((obj:any)=>{return obj.value == this.presentTaskObject.assignee});
					let reviewerObj:any=this.optionsUserArray.find((obj:any)=>{return obj.value == this.presentTaskObject.auditor})
					this.presentTaskObject.assignee = userObj;
					this.presentAssignee = userObj != undefined ? userObj.value : 'N/A';

					if(userObj != undefined && userObj != null && userObj != ''){
						this.TeamLeaderValue = userObj.value
					}
					if(reviewerObj != undefined || reviewerObj != null || reviewerObj != ''){
						this.TeamReviewerValue = reviewerObj.value
					}
					if(this.presentTaskObject.dueDate!=undefined && this.presentTaskObject.dueDate!=''){
						this.presentTaskObject.dueDate=moment(this.presentTaskObject.dueDate).format('YYYY-MM-DD')
					}

				this.controlsArray = this.presentTaskObject.frameworks.filter((obj : any)=>{
					return this.presentAuditObject.frameworks.includes(obj.framework)
				})

			   	this.controlsArray.forEach((item: any) => {
					this.controlDetailsArray = item.controls.map((controlNumber: any) => this.getControlDetails(controlNumber)).filter(Boolean);
					item.controlsDetailsArray = this.controlDetailsArray; 
					delete item.controls;
				});
				// evidenceArray
				this.evidenceArray = []
				if(this.presentTaskObject.files){
					this.presentTaskObject.files.forEach((fileObj: any, index: number) => {
						const filename = fileObj?.filename || fileObj?.name || '';
						if (!filename) return;
						const value = fileObj?.url ? String(fileObj.url) : `${filename}::${index}`;
						this.evidenceArray.push({ filename, value });
					});
				}
				
			});
		},
		async getAuditFindings(aId:any,tId:any){
			const auditId = aId || this.currentAuditId;
			const taskId = tId || this.currentTaskId;
			this.findingsForTask = []
			if (!auditId || !taskId) {
				return;
			}
			await this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/org/audit/${auditId}/task/${taskId}/findings`).then(async (result: any) => {
				this.findingsForTask = result.data || [];
			})
		}
	},
	async mounted(){
		await this.loadFindingSeverityLabelOptions();
		emitter.off('addedComments');
		emitter.on('addedComments',(data: any)=>{
			this.comment = data.comments
			this.addComment()
		})
		emitter.on('activiteToolTip', this.onActivateToolTip);
		emitter.on('deActiviteToolTip', this.onDeactivateToolTip);
	},
	beforeUnmount() {
		 sessionStorage.removeItem('selectedTab')
		 emitter.off('activiteToolTip', this.onActivateToolTip);
		 emitter.off('deActiviteToolTip', this.onDeactivateToolTip);
	 },
	async created() {
		 const savedTabKey = sessionStorage.getItem('selectedTab');
			if (savedTabKey) {
			const savedTab = this.tabHead.find((tab: any) => tab.id == savedTabKey);
				if (savedTab) {
					this.toggleTabs(savedTab);
				}
				else{
					this.selectedTabObj = { displayName: 'Description', id: 1 };
	            	this.selectedTabIndex = 1; 
				}
		}
		else{
			 this.selectedTabObj = { displayName: 'Description', id: 1 };
		     this.selectedTabIndex = 1;
		}
		this.tabDataLoading = true
		await this.getAuditTaskStatuses();
		await this.getAllActiveUsers();
		await this.getAllTeams();
		// await this.getAllControls();
		
		
		await this.getPresentAuditObject();
		

		await this.getallEntities();
		await this.getPresentTaskObject(this.currentAuditId,this.currentTaskId);

		// await this.getAuditFindings(this.currentAuditId,this.currentTaskId)
		await this.getAllBusinessProcesses();
		await this.getAllSystems();
		
		// await this.getTaskHistoryObject();
		// await this.getplannerTasksForAudit();
		this.tabDataLoading = false
		this.findingsObjectDummy = { ...this.findingsObject };

		if(this.isMyTasks){
        this.routesArray = [
            { name: 'My Tasks', routeName: 'myTasks' },
			{ name: this.presentTaskObject.taskId, routeName: 'controlEdit' }
        ];
        }else{
           this.routesArray = [
            { name: 'Audit' , routeName: 'audit' },
            { name: this.presentAuditObject.title, routeName: 'view-audit' },
            { name: 'Tasks', routeName: 'start-audit' },
			{ name: this.presentTaskObject.taskId, routeName: 'controlEdit' }
        ];
        }
		// this.navIndexNums = { index: 1, name: 'Description' };
		if(this.presentTaskObject.comments != undefined){
			this.presentTaskObject.comments.sort().reverse();
		}
		if(this.presentTaskObject!=undefined && this.presentTaskObject.statusCode==10401) this.disabledStatuses = [];
		else if(this.presentTaskObject!=undefined && this.presentTaskObject.statusCode==10421) this.disabledStatuses = [10401];
		else if(this.presentTaskObject!=undefined && this.presentTaskObject.statusCode==10414) this.disabledStatuses = [10401, 10421];
		else if(this.presentTaskObject!=undefined && this.presentTaskObject.statusCode == 10415 ) this.disabledStatuses = [10401];
		else if(this.presentTaskObject!=undefined && this.presentTaskObject.statusCode == 10416 ) this.disabledStatuses = [10401];
		else if(this.presentTaskObject!=undefined && this.presentTaskObject.statusCode == 10403) this.disabledStatuses = [10401,10421,10414,10416];
		else if(this.presentTaskObject!=undefined && this.presentTaskObject.statusCode == 10417) this.disabledStatuses = [10401,10421,10414,10416,10403]
		else this.disabledStatuses = [];
	}
});
</script>
